// import { useState, useEffect, useRef } from "react";
// import { useHistory } from "react-router-dom"; // Add this import
// import Grid2 from "@mui/material/Unstable_Grid2";
// import {
//   Box, Button, Typography, Container, Chip, Card, CardContent,
//   AppBar, Toolbar, IconButton, Drawer, List, ListItem, Avatar,
//   Divider, Stack,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import MenuIcon from "@mui/icons-material/Menu";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
// import TranslateIcon from "@mui/icons-material/Translate";
// import SpellcheckIcon from "@mui/icons-material/Spellcheck";
// import AutoStoriesIcon from "@mui/icons-material/AutoStories";
// import RssFeedIcon from "@mui/icons-material/RssFeed";
// import FindReplaceIcon from "@mui/icons-material/FindReplace";
// import PolicyIcon from "@mui/icons-material/Policy";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import BusinessIcon from "@mui/icons-material/Business";
// import CampaignIcon from "@mui/icons-material/Campaign";
// import PsychologyIcon from "@mui/icons-material/Psychology";
// import DeskIcon from "@mui/icons-material/Desk";
// import ImageIcon from "@mui/icons-material/Image";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import GroupsIcon from "@mui/icons-material/Groups";
// import DescriptionIcon from "@mui/icons-material/Description";
// import ShareIcon from "@mui/icons-material/Share";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import StarIcon from "@mui/icons-material/Star";
// import CloseIcon from "@mui/icons-material/Close";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
// import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import GoogleIcon from "@mui/icons-material/Google";
// import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
// import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
// import PersonSearchIcon from "@mui/icons-material/PersonSearch";
// import BrushIcon from "@mui/icons-material/Brush";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// // Import auth service (adjust the path as needed)
// import auth from "../../services/authService"; // Add this import

// // Import logo (make sure to add your logo file to the project)
// import synlogo from "../../static/POET_Logo_Pen.png"; // Adjust the path as needed

// // ─── THEME: White + Golden ────────────────────────────────────────────────────
// const theme = createTheme({
//   palette: {
//     mode: "light",
//     primary:    { main: "#B8860B" },
//     secondary:  { main: "#D4A017" },
//     background: { default: "#FDFAF4", paper: "#FFFEF9" },
//     text:       { primary: "#2C2410", secondary: "#6B5A3A" },
//   },
//   typography: { fontFamily: "'Sora', 'DM Sans', sans-serif" },
// });

// // ─── COLOR TOKENS ─────────────────────────────────────────────────────────────
// const G = {
//   // Backgrounds
//   pageBg:    "#FDFAF4",
//   cardBg:    "#FFFEF9",
//   cardBg2:   "#FFF8E8",
//   heroTop:   "#FFFDF5",
//   // Golds
//   gold1:     "#B8860B",   // dark gold
//   gold2:     "#D4A017",   // mid gold
//   gold3:     "#F0C040",   // bright gold
//   gold4:     "#FAE08A",   // pale gold
//   gold5:     "#FFF8DC",   // cream
//   // Accent colors for tools (jewel on white)
//   sky:       "#1E7DB8",   // blue
//   sage:      "#2E7D52",
//   lavender:  "#6A4FAB",
//   coral:     "#C0392B",
//   rose:      "#A0395A",
//   teal:      "#0E8585",
//   amber:     "#B8860B",
//   // Text
//   textDark:  "#1A1205",
//   textMid:   "#4A3A1A",
//   textLight: "#8A7350",
//   textBlack: "#000000", // Added pure black for subtitle
//   // Borders
//   borderGold:"#E8CC80",
//   borderSoft:"#F0E4C0",
// };

// // ─── ALL 27 TOOLS ─────────────────────────────────────────────────────────────
// const ALL_TOOLS = [
//   { icon: <TranslateIcon />,       name: "Smart Translator",        desc: "100+ languages, deep context AI",        color: G.sky,      cat: "Language", dot: "#1E7DB8" },
//   { icon: <SpellcheckIcon />,      name: "Grammar Check",           desc: "Semantic grammar & style correction",    color: G.sage,     cat: "Language", dot: "#2E7D52" },
//   { icon: <FindReplaceIcon />,     name: "AI Paraphraser",          desc: "Rephrase preserving your voice",         color: G.lavender, cat: "Language", dot: "#6A4FAB" },
//   { icon: <PolicyIcon />,          name: "AI Plagiarism Checker",   desc: "Instant originality detection",          color: G.coral,    cat: "Language", dot: "#C0392B" },
//   { icon: <FormatQuoteIcon />,     name: "AI Citation Generator",   desc: "APA, MLA, Chicago & more",               color: G.rose,     cat: "Language", dot: "#A0395A" },
//   { icon: <SummarizeIcon />,       name: "AI Summarizer",           desc: "Condense content intelligently",         color: G.teal,     cat: "Language", dot: "#0E8585" },
//   { icon: <PsychologyIcon />,      name: "AI Humanizer",            desc: "Make AI text sound human",               color: G.amber,    cat: "Language", dot: "#B8860B" },
//   { icon: <AutoStoriesIcon />,     name: "AI Book Writing Tool",    desc: "Ideas · Outline · Cover · Summary",      color: G.gold2,    cat: "Content",  dot: "#D4A017" },
//   { icon: <LibraryBooksIcon />,    name: "Book Outline Builder",    desc: "Structure every chapter precisely",      color: G.amber,    cat: "Content",  dot: "#B8860B" },
//   { icon: <FormatAlignLeftIcon />, name: "Book Summary AI",         desc: "Generate compelling blurbs fast",        color: G.sage,     cat: "Content",  dot: "#2E7D52" },
//   { icon: <BrushIcon />,           name: "Cover Ideas Generator",   desc: "Visual concepts for your cover",         color: G.rose,     cat: "Content",  dot: "#A0395A" },
//   { icon: <RssFeedIcon />,         name: "AI Blog Generator",       desc: "SEO-ready articles in seconds",          color: G.teal,     cat: "Content",  dot: "#0E8585" },
//   { icon: <BusinessIcon />,        name: "AI Business Tools",       desc: "Slogan · Strategy · Ideas · Persona",    color: G.sky,      cat: "Business", dot: "#1E7DB8" },
//   { icon: <RecordVoiceOverIcon />, name: "Slogan Generator",        desc: "Memorable taglines instantly",           color: G.coral,    cat: "Business", dot: "#C0392B" },
//   { icon: <AutoAwesomeIcon />,     name: "Brand Strategy AI",       desc: "Positioning, voice & identity",          color: G.lavender, cat: "Business", dot: "#6A4FAB" },
//   { icon: <EmojiObjectsIcon />,    name: "Business Idea Generator", desc: "Validated ideas for your venture",       color: G.gold2,    cat: "Business", dot: "#D4A017" },
//   { icon: <PersonSearchIcon />,    name: "Persona Generator",       desc: "Detailed buyer personas at scale",       color: G.amber,    cat: "Business", dot: "#B8860B" },
//   { icon: <InstagramIcon />,       name: "Instagram Ads AI",        desc: "Scroll-stopping ad copy",                color: G.rose,     cat: "Ads",      dot: "#A0395A" },
//   { icon: <LinkedInIcon />,        name: "LinkedIn Ads AI",         desc: "Professional ad copy that converts",     color: G.sky,      cat: "Ads",      dot: "#1E7DB8" },
//   { icon: <TwitterIcon />,         name: "Twitter / X Ads",         desc: "Short-form ads that drive clicks",       color: G.lavender, cat: "Ads",      dot: "#6A4FAB" },
//   { icon: <GoogleIcon />,          name: "Google Ads AI",           desc: "Headlines & descriptions that rank",     color: G.teal,     cat: "Ads",      dot: "#0E8585" },
//   { icon: <CampaignIcon />,        name: "AI Advertising Tool",     desc: "Cross-platform ad campaigns",            color: G.coral,    cat: "Ads",      dot: "#C0392B" },
//   { icon: <DeskIcon />,            name: "AI SmartDesk",            desc: "All-in-one AI workspace hub",            color: G.gold2,    cat: "Workspace",dot: "#D4A017" },
//   { icon: <ImageIcon />,           name: "AI Image Generator",      desc: "Stunning visuals from text",             color: G.sky,      cat: "Workspace",dot: "#1E7DB8" },
//   { icon: <GroupsIcon />,          name: "Smart Teams",             desc: "Collaborate with AI assistance",         color: G.sage,     cat: "Workspace",dot: "#2E7D52" },
//   { icon: <DescriptionIcon />,     name: "Smart Doc Creation",      desc: "AI drafts your documents",               color: G.teal,     cat: "Workspace",dot: "#0E8585" },
//   { icon: <ShareIcon />,           name: "Smart Doc Collaboration", desc: "Real-time AI-powered co-editing",        color: G.lavender, cat: "Workspace",dot: "#6A4FAB" },
// ];

// // floating positions for each tool pill in the hero (x%, y%, scale, delay, duration)
// const FLOAT_CONFIG = [
//   { x:  3, y: 10, s: 1.00, d: 0.0,  dur: 6.0 },
//   { x: 72, y:  5, s: 0.90, d: 1.2,  dur: 7.5 },
//   { x: 85, y: 18, s: 1.05, d: 0.5,  dur: 5.8 },
//   { x: 10, y: 30, s: 0.85, d: 2.0,  dur: 8.0 },
//   { x: 60, y: 28, s: 0.95, d: 0.8,  dur: 6.5 },
//   { x: 88, y: 42, s: 0.80, d: 1.5,  dur: 7.0 },
//   { x:  5, y: 52, s: 1.00, d: 0.3,  dur: 5.5 },
//   { x: 75, y: 55, s: 0.88, d: 2.5,  dur: 8.5 },
//   { x: 42, y: 62, s: 0.92, d: 1.0,  dur: 6.8 },
//   { x: 15, y: 72, s: 0.96, d: 1.8,  dur: 7.2 },
//   { x: 82, y: 72, s: 0.84, d: 0.6,  dur: 6.2 },
//   { x: 35, y: 80, s: 1.02, d: 2.2,  dur: 5.9 },
//   { x: 60, y: 85, s: 0.90, d: 0.9,  dur: 7.8 },
//   { x:  7, y: 88, s: 0.82, d: 1.4,  dur: 8.2 },
//   { x: 90, y: 88, s: 0.95, d: 0.2,  dur: 6.6 },
//   { x: 48, y:  8, s: 0.88, d: 1.7,  dur: 7.4 },
//   { x: 25, y: 18, s: 1.00, d: 0.4,  dur: 5.7 },
//   { x: 55, y: 48, s: 0.93, d: 2.1,  dur: 8.1 },
//   { x: 20, y: 45, s: 0.86, d: 1.1,  dur: 6.9 },
//   { x: 70, y: 38, s: 0.97, d: 1.6,  dur: 7.6 },
//   { x: 32, y: 35, s: 0.91, d: 0.7,  dur: 5.6 },
//   { x: 78, y: 25, s: 0.83, d: 2.3,  dur: 8.3 },
//   { x: 50, y: 70, s: 1.01, d: 1.3,  dur: 6.4 },
//   { x: 12, y: 60, s: 0.87, d: 0.1,  dur: 7.9 },
//   { x: 65, y: 15, s: 0.94, d: 1.9,  dur: 6.1 },
//   { x: 40, y: 92, s: 0.89, d: 2.4,  dur: 7.3 },
//   { x: 22, y: 95, s: 0.96, d: 0.5,  dur: 5.4 },
// ];

// // ─── CATEGORIES ───────────────────────────────────────────────────────────────
// const CATEGORIES = [
//   { label: "Language & Writing", color: G.sky,      anim: "flipY"    },
//   { label: "Content Creation",   color: G.gold2,    anim: "zoomSpin" },
//   { label: "Business & Brand",   color: G.teal,     anim: "slideUp"  },
//   { label: "Advertising",        color: G.coral,    anim: "dropBounce"},
//   { label: "Workspace",          color: G.lavender, anim: "swingDown"},
// ];

// const PRICING = [
//   { name:"Starter",    price:"0",  features:["5 tools access","100 AI credits/mo","Basic support","1 workspace"],                                                                    cta:"Get Started Free",hi:false},
//   { name:"Pro",        price:"19", features:["All 27+ tools","5,000 AI credits/mo","Priority support","5 workspaces","Team collaboration","Advanced export"],                       cta:"Start Pro Trial", hi:true },
//   { name:"Enterprise", price:"79", features:["Unlimited tools","Unlimited AI credits","24/7 dedicated support","Unlimited workspaces","Custom AI training","API access","SSO"],    cta:"Contact Sales",   hi:false},
// ];

// const TESTIMONIALS = [
//   {name:"Amara Osei", role:"Content Director",av:"A",text:"Synthium replaced 6 different tools. My team's output tripled in the first month.",stars:5},
//   {name:"Lena Kovač", role:"Solo Founder",    av:"L",text:"The AI Business Tools helped me launch my brand in days, not months. Absolutely unreal.",stars:5},
//   {name:"Marcus Tran",role:"Novel Author",    av:"M",text:"The Book Writing Tool understood my genre, voice, and plot — like having a co-author.",stars:5},
// ];

// // Styles object for custom styling
// const styles = {
//   logoTitle: {
//     fontSize: '16px',
//     fontWeight: 900,
//     color: 'rgb(47, 62, 226)', // Blue color for title (same for header and footer)
//     letterSpacing: '-0.5px',
//     lineHeight: 1.2,
//   },
//   logoSubtitle: {
//     fontSize: '9px',
//     color: '#000000', // Black color for subtitle (same for header and footer)
//     letterSpacing: '1px',
//     fontWeight: 600,
//     textTransform: 'uppercase',
//   },
//   footerLogoTitle: {
//     fontSize: '18px',
//     fontWeight: 900,
//     color: 'rgb(47, 62, 226)', // Blue color for title (matching header)
//     letterSpacing: '-0.5px',
//     lineHeight: 1.2,
//   },
//   footerLogoSubtitle: {
//     fontSize: '10px',
//     color: '#000000', // Black color for subtitle (matching header)
//     letterSpacing: '1px',
//     fontWeight: 600,
//     textTransform: 'uppercase',
//   },
// };

// // ─── FLOATING TOOL PILLS (hero background, like the reference image) ──────────
// function FloatingToolPills() {
//   return (
//     <Box sx={{ position:"absolute", inset:0, pointerEvents:"none", zIndex:1, overflow:"hidden" }}>
//       {/* Soft radial vignette so pills don't compete with hero text */}
//       <Box sx={{
//         position:"absolute", inset:0, zIndex:10,
//         background:`
//           radial-gradient(ellipse 68% 60% at 50% 50%, rgba(253,250,244,0.92) 18%, rgba(253,250,244,0.55) 55%, transparent 80%),
//           linear-gradient(to bottom, rgba(253,250,244,0.98) 0%, rgba(253,250,244,0.3) 20%, rgba(253,250,244,0.3) 80%, rgba(253,250,244,0.98) 100%)
//         `,
//       }}/>

//       {ALL_TOOLS.map((tool, i) => {
//         const cfg = FLOAT_CONFIG[i] || { x:50, y:50, s:1, d:0, dur:7 };
//         const animName = `float_${i}`;
//         // Each pill gets a slightly different float path
//         const yAmt = 14 + (i % 5) * 4;
//         const xAmt = (i % 3 - 1) * 6;
//         const rot  = (i % 2 === 0 ? 1 : -1) * (1 + i % 3);

//         return (
//           <Box
//             key={tool.name}
//             sx={{
//               position:"absolute",
//               left:`${cfg.x}%`,
//               top:`${cfg.y}%`,
//               transform:`scale(${cfg.s})`,
//               transformOrigin:"center center",
//               display:"flex", alignItems:"center", gap:"8px",
//               px:"14px", py:"9px",
//               background:`linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,252,235,0.88))`,
//               backdropFilter:"blur(12px)",
//               border:`1.5px solid ${tool.color}45`,
//               borderRadius:"40px",
//               boxShadow:`
//                 0 4px 20px rgba(0,0,0,0.08),
//                 0 1px 4px rgba(0,0,0,0.06),
//                 inset 0 1px 0 rgba(255,255,255,0.9),
//                 0 0 0 1px ${tool.color}18
//               `,
//               whiteSpace:"nowrap",
//               animation:`${animName} ${cfg.dur}s ease-in-out ${cfg.d}s infinite`,
//               [`@keyframes ${animName}`]:{
//                 "0%,100%":{ transform:`scale(${cfg.s}) translate(0px,0px) rotate(0deg)` },
//                 "33%":    { transform:`scale(${cfg.s}) translate(${xAmt}px,-${yAmt * 0.6}px) rotate(${rot * 0.5}deg)` },
//                 "66%":    { transform:`scale(${cfg.s}) translate(${-xAmt * 0.5}px,-${yAmt}px) rotate(${rot}deg)` },
//               },
//             }}
//           >
//             {/* Colored dot like the reference image */}
//             <Box sx={{
//               width:8, height:8, borderRadius:"50%",
//               background:tool.dot,
//               flexShrink:0,
//               boxShadow:`0 0 6px ${tool.dot}80`,
//             }}/>
//             <Typography sx={{
//               fontSize:12.5, fontWeight:700,
//               color:G.textDark,
//               letterSpacing:0.2,
//             }}>
//               {tool.name}
//             </Typography>
//           </Box>
//         );
//       })}
//     </Box>
//   );
// }

// // ─── ANIMATED TOOL CARD (5 unique animations) ─────────────────────────────────
// function ToolCard({ tool, anim, idx }) {
//   const [hovered, setHovered] = useState(false);
//   const c = tool.color;

//   const variants = {
//     flipY: {
//       entrance: `tflipY 0.65s cubic-bezier(0.23,1,0.32,1) ${idx*0.07}s both`,
//       kf:{ "@keyframes tflipY":{ "0%":{opacity:0,transform:"perspective(700px) rotateY(-90deg) scale(0.85)"}, "100%":{opacity:1,transform:"perspective(700px) rotateY(0deg) scale(1)"} } },
//       hover:"perspective(900px) rotateY(8deg) rotateX(-4deg) translateY(-8px)",
//     },
//     zoomSpin:{
//       entrance:`tzoomSpin 0.7s cubic-bezier(0.34,1.56,0.64,1) ${idx*0.09}s both`,
//       kf:{ "@keyframes tzoomSpin":{ "0%":{opacity:0,transform:"scale(0.1) rotate(-240deg)"}, "100%":{opacity:1,transform:"scale(1) rotate(0deg)"} } },
//       hover:"scale(1.07) rotate(1.5deg) translateY(-7px)",
//     },
//     slideUp:{
//       entrance:`tslideUp 0.6s cubic-bezier(0.23,1,0.32,1) ${idx*0.08}s both`,
//       kf:{ "@keyframes tslideUp":{ "0%":{opacity:0,transform:"translateY(50px) skewY(4deg)"}, "70%":{transform:"translateY(-6px) skewY(-1deg)"}, "100%":{opacity:1,transform:"translateY(0) skewY(0)"} } },
//       hover:"perspective(700px) rotateX(-8deg) translateY(-8px)",
//     },
//     dropBounce:{
//       entrance:`tdropBounce 0.8s cubic-bezier(0.34,1.4,0.64,1) ${idx*0.06}s both`,
//       kf:{ "@keyframes tdropBounce":{ "0%":{opacity:0,transform:"translateY(-60px) scaleY(1.4)"}, "55%":{transform:"translateY(10px) scaleY(0.88)"}, "80%":{transform:"translateY(-4px) scaleY(1.03)"}, "100%":{opacity:1,transform:"translateY(0) scaleY(1)"} } },
//       hover:"translateY(-10px) scale(1.05) perspective(600px) rotateX(5deg)",
//     },
//     swingDown:{
//       entrance:`tswingDown 0.85s cubic-bezier(0.23,1,0.32,1) ${idx*0.08}s both`,
//       kf:{ "@keyframes tswingDown":{ "0%":{opacity:0,transform:"perspective(700px) rotateX(80deg)",transformOrigin:"top center"}, "70%":{transform:"perspective(700px) rotateX(-5deg)",transformOrigin:"top center"}, "100%":{opacity:1,transform:"perspective(700px) rotateX(0deg)",transformOrigin:"top center"} } },
//       hover:"perspective(800px) rotateX(-7deg) rotateY(5deg) translateY(-7px)",
//     },
//   };

//   const v = variants[anim] || variants.flipY;

//   return (
//     <Card
//       onMouseEnter={()=>setHovered(true)}
//       onMouseLeave={()=>setHovered(false)}
//       sx={{
//         background: hovered
//           ? `linear-gradient(145deg, ${c}12, ${c}05, #FFFEF9)`
//           : "#FFFEF9",
//         border:`1.5px solid ${hovered ? c+"70" : G.borderSoft}`,
//         borderRadius:"18px",
//         cursor:"pointer",
//         position:"relative", overflow:"hidden",
//         transform: hovered ? v.hover : "none",
//         transition:"all 0.42s cubic-bezier(0.23,1,0.32,1)",
//         boxShadow: hovered
//           ? `0 24px 60px ${c}25, 0 4px 16px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,1)`
//           : "0 2px 12px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
//         opacity:0,
//         animation: v.entrance,
//         ...v.kf,
//         height:"100%",
//       }}
//     >
//       {/* Top shimmer */}
//       <Box sx={{
//         position:"absolute",top:0,left:0,right:0,height:"2.5px",
//         background:`linear-gradient(90deg, transparent, ${c}, transparent)`,
//         opacity: hovered ? 1 : 0, transition:"opacity 0.35s",
//       }}/>
//       {/* Glow corner */}
//       <Box sx={{
//         position:"absolute",top:-30,right:-30,
//         width:110,height:110,borderRadius:"50%",
//         background:`radial-gradient(circle, ${c}28, transparent 70%)`,
//         filter:"blur(20px)",
//         opacity: hovered ? 1 : 0, transition:"opacity 0.5s",
//       }}/>

//       <CardContent sx={{ p:3, position:"relative", zIndex:1 }}>
//         {/* Icon */}
//         <Box sx={{
//           width:52, height:52, borderRadius:"14px", mb:2.5,
//           background: hovered
//             ? `linear-gradient(135deg, ${c}25, ${c}0E)`
//             : `linear-gradient(135deg, ${c}18, ${c}08)`,
//           border:`1.5px solid ${c}35`,
//           display:"flex",alignItems:"center",justifyContent:"center",
//           color:c, fontSize:24,
//           boxShadow: hovered ? `0 0 20px ${c}45` : "none",
//           transform: hovered ? "scale(1.15) rotateZ(-7deg)" : "scale(1) rotateZ(0deg)",
//           transition:"all 0.4s cubic-bezier(0.34,1.56,0.64,1)",
//         }}>
//           {tool.icon}
//         </Box>

//         <Typography variant="subtitle1" fontWeight={800} sx={{ color:G.textDark, mb:0.8, fontSize:14.5, lineHeight:1.3 }}>
//           {tool.name}
//         </Typography>
//         <Typography variant="body2" sx={{ color:G.textLight, lineHeight:1.65, fontSize:12.5 }}>
//           {tool.desc}
//         </Typography>

//         <Box sx={{
//           display:"flex",alignItems:"center",gap:0.5,mt:2.5,
//           opacity: hovered ? 1 : 0,
//           transform: hovered ? "translateX(0)" : "translateX(-12px)",
//           transition:"all 0.32s cubic-bezier(0.23,1,0.32,1)",
//         }}>
//           <Typography variant="caption" sx={{ color:c, fontWeight:800, fontSize:12 }}>
//             Launch
//           </Typography>
//           <ArrowForwardIcon sx={{ fontSize:14, color:c }}/>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// }

// // ─── DEMO MODAL ───────────────────────────────────────────────────────────────
// function DemoModal({ open, onClose }) {
//   if (!open) return null;
//   return (
//     <Box onClick={onClose} sx={{
//       position:"fixed",inset:0,zIndex:9999,
//       background:"rgba(20,14,4,0.75)",backdropFilter:"blur(14px)",
//       display:"flex",alignItems:"center",justifyContent:"center",
//       animation:"mFade 0.3s ease both",
//       "@keyframes mFade":{ from:{opacity:0}, to:{opacity:1} },
//     }}>
//       <Box onClick={e=>e.stopPropagation()} sx={{
//         width:{xs:"95vw",md:"72vw"},maxWidth:920,
//         background:"#FFFEF9",
//         border:`1.5px solid ${G.borderGold}`,borderRadius:"20px",p:4,position:"relative",
//         boxShadow:"0 32px 100px rgba(0,0,0,0.18)",
//         animation:"mScale 0.4s cubic-bezier(0.23,1,0.32,1) both",
//         "@keyframes mScale":{ from:{transform:"scale(0.82)",opacity:0}, to:{transform:"scale(1)",opacity:1} },
//       }}>
//         <IconButton onClick={onClose} sx={{ position:"absolute",top:14,right:14, color:G.textLight }}><CloseIcon/></IconButton>
//         <Typography variant="h4" fontWeight={900} sx={{ color:G.textDark, mb:0.5 }}>See Synthium in Action</Typography>
//         <Typography sx={{ color:G.textLight, mb:4 }}>A 2-minute tour of the full creative suite</Typography>
//         <Box sx={{
//           width:"100%",aspectRatio:"16/9",
//           background:`linear-gradient(135deg, ${G.gold5}, #FFF9E0)`,
//           borderRadius:"12px",border:`1.5px solid ${G.borderGold}`,
//           display:"flex",alignItems:"center",justifyContent:"center",
//         }}>
//           <Box sx={{
//             width:80,height:80,borderRadius:"50%",
//             background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//             display:"flex",alignItems:"center",justifyContent:"center",
//             cursor:"pointer",
//             boxShadow:`0 0 0 12px ${G.gold3}30, 0 0 60px ${G.gold1}60`,
//             animation:"mpulse 2s ease-in-out infinite",
//             "@keyframes mpulse":{ "0%,100%":{transform:"scale(1)"}, "50%":{transform:"scale(1.09)"} },
//           }}>
//             <PlayArrowIcon sx={{ fontSize:42, color:"white" }}/>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// // ─── MAIN ─────────────────────────────────────────────────────────────────────
// export default function SynthiumLanding() {
//   const history = useHistory(); // Add this hook
//   const [activeTab, setActiveTab] = useState(0);
//   const [demoOpen, setDemoOpen]   = useState(false);
//   const [drawer, setDrawer]       = useState(false);
//   const [scrollY, setScrollY]     = useState(0);
//   const [tabKey, setTabKey]       = useState(0);

//   // Refs for navigation
//   const featuresRef = useRef(null);
//   const toolsRef = useRef(null);
//   const pricingRef = useRef(null);
//   const teamsRef = useRef(null);

//   useEffect(()=>{
//     const link=document.createElement("link");
//     link.href="https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700;800;900&family=DM+Sans:wght@400;500;600;700&display=swap";
//     link.rel="stylesheet";
//     document.head.appendChild(link);
//     const fn=()=>setScrollY(window.scrollY);
//     window.addEventListener("scroll",fn);
//     return()=>window.removeEventListener("scroll",fn);
//   },[]);

//   // Navigation handlers
//   const handleLoginClick = () => {
//     localStorage.removeItem("is_guest");
//     localStorage.removeItem("guest_id");
//     localStorage.removeItem("guest_user");
//     window.location.href = "/login";
//   };

//   const handleSignUpClick = () => {
//     window.location.href = "/signup";
//   };

//   const handleTryFreeClick = async () => {
//     try {
//       await auth.guestLogin();
//       window.location.href = "/docTags";
//     } catch (error) {
//       console.error("Guest login failed", error);
//       // Optionally show an error message to the user
//     }
//   };

//   const switchTab=(i)=>{ setActiveTab(i); setTabKey(k=>k+1); };

//   // Navigation function
//   const scrollToSection = (ref) => {
//     if (ref.current) {
//       ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
//     }
//     setDrawer(false); // Close mobile drawer after navigation
//   };

//   const catTools=(cat)=>ALL_TOOLS.filter(t=>{
//     if(cat==="Language & Writing")return t.cat==="Language";
//     if(cat==="Content Creation")  return t.cat==="Content";
//     if(cat==="Business & Brand")  return t.cat==="Business";
//     if(cat==="Advertising")       return t.cat==="Ads";
//     if(cat==="Workspace")         return t.cat==="Workspace";
//     return false;
//   });

//   /* Shared section heading */
//   const SectionHeading=({chip,chipColor,title,sub})=>(
//     <Box sx={{ textAlign:"center", mb:8 }}>
//       <Chip label={chip} sx={{ mb:2, background:`${chipColor}15`, color:chipColor, fontWeight:700, letterSpacing:2, border:`1px solid ${chipColor}35`, fontSize:12 }}/>
//       <Typography variant="h2" fontWeight={900} sx={{
//         fontSize:{xs:"2rem",md:"3.3rem"}, mb:2, lineHeight:1.15,
//         background:`linear-gradient(135deg, ${G.textDark} 0%, ${G.gold1} 60%, ${G.gold2} 100%)`,
//         WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent",
//       }}>{title}</Typography>
//       {sub && <Typography sx={{ color:G.textLight, maxWidth:580, mx:"auto", fontSize:"1.05rem", lineHeight:1.75 }}>{sub}</Typography>}
//     </Box>
//   );

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{
//         background:G.pageBg,
//         minHeight:"100vh",
//         overflowX:"hidden",
//         fontFamily:"'Sora','DM Sans',sans-serif",
//       }}>

//         {/* Very subtle gold dot texture */}
//         <Box sx={{
//           position:"fixed",inset:0,pointerEvents:"none",zIndex:0,
//           backgroundImage:`radial-gradient(circle, ${G.gold3}22 1px, transparent 1px)`,
//           backgroundSize:"52px 52px",
//         }}/>

//         {/* ── NAVBAR ─────────────────────────────────────────────────────────── */}
//         <AppBar elevation={0} sx={{
//           background: G.pageBg, // Always use page background color for consistency with hero
//           backdropFilter:"blur(20px)",
//           borderBottom:`1px solid ${G.borderGold}`,
//           transition:"all 0.35s ease",
//           zIndex:100,
//         }}>
//           <Toolbar sx={{ maxWidth:1400, mx:"auto", width:"100%", px:{xs:2,md:4} }}>
//             {/* Logo with image and text - Header */}
//             <Box
//               onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1.5,
//                 mr: 6,
//                 cursor: "pointer"
//               }}
//             >
//               <Box
//                 component="img"
//                 src={synlogo}
//                 alt="Synthium Logo"
//                 sx={{
//                   width: 40,
//                   height: 40,
//                   objectFit: "contain",
//                 }}
//               />
//               <Box>
//                 <Typography sx={styles.logoTitle}>SYNTHIUM</Typography>
//                 <Typography sx={styles.logoSubtitle}>Creative Suite</Typography>
//               </Box>
//             </Box>

//             <Box sx={{ display:{xs:"none",md:"flex"}, gap:4, flex:1 }}>
//               <Typography
//                 onClick={() => scrollToSection(toolsRef)}
//                 sx={{
//                   color:G.textLight, fontSize:14, fontWeight:600, cursor:"pointer",
//                   "&:hover":{color:G.gold1}, transition:"color 0.2s",
//                 }}
//               >Features</Typography>
//               <Typography
//                 onClick={() => scrollToSection(pricingRef)}
//                 sx={{
//                   color:G.textLight, fontSize:14, fontWeight:600, cursor:"pointer",
//                   "&:hover":{color:G.gold1}, transition:"color 0.2s",
//                 }}
//               >Pricing</Typography>
//               <Typography
//                 onClick={() => scrollToSection(teamsRef)}
//                 sx={{
//                   color:G.textLight, fontSize:14, fontWeight:600, cursor:"pointer",
//                   "&:hover":{color:G.gold1}, transition:"color 0.2s",
//                 }}
//               >Teams</Typography>
//             </Box>

//             <Box sx={{ display:"flex",gap:2,ml:"auto" }}>
//               <Button
//                 variant="text"
//                 onClick={handleLoginClick} // Add click handler
//                 sx={{ color:G.textMid, display:{xs:"none",md:"flex"}, fontWeight:600, "&:hover":{color:G.gold1} }}
//               >
//                 Log In
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={handleSignUpClick} // Add click handler
//                 sx={{
//                   background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//                   color:"white", borderRadius:"10px", px:3, fontWeight:700, fontSize:14,
//                   display:{xs:"none",md:"flex"},
//                   boxShadow:`0 4px 20px ${G.gold2}50`,
//                   "&:hover":{ boxShadow:`0 8px 32px ${G.gold2}70`, transform:"translateY(-1px)" },
//                   transition:"all 0.2s",
//                 }}
//               >
//                 Sign Up
//               </Button>
//               <IconButton onClick={()=>setDrawer(true)} sx={{ display:{md:"none"}, color:G.textDark }}><MenuIcon/></IconButton>
//             </Box>
//           </Toolbar>
//         </AppBar>

//         {/* Mobile Drawer */}
//         <Drawer anchor="right" open={drawer} onClose={()=>setDrawer(false)}
//           PaperProps={{ sx:{ background:G.cardBg, borderLeft:`1px solid ${G.borderGold}`, width:280 } }}>
//           <Box sx={{ p:3 }}>
//             <IconButton onClick={()=>setDrawer(false)} sx={{ color:G.textLight, mb:2 }}><CloseIcon/></IconButton>
//             <List>
//               <ListItem
//                 onClick={() => scrollToSection(featuresRef)}
//                 sx={{ py:1.5, color:G.textMid, cursor:"pointer", borderRadius:"10px",
//                 "&:hover":{ background:`${G.gold2}15`, color:G.gold1 } }}
//               >Features</ListItem>
//               <ListItem
//                 onClick={() => scrollToSection(toolsRef)}
//                 sx={{ py:1.5, color:G.textMid, cursor:"pointer", borderRadius:"10px",
//                 "&:hover":{ background:`${G.gold2}15`, color:G.gold1 } }}
//               >Tools</ListItem>
//               <ListItem
//                 onClick={() => scrollToSection(pricingRef)}
//                 sx={{ py:1.5, color:G.textMid, cursor:"pointer", borderRadius:"10px",
//                 "&:hover":{ background:`${G.gold2}15`, color:G.gold1 } }}
//               >Pricing</ListItem>
//               <ListItem
//                 onClick={() => scrollToSection(teamsRef)}
//                 sx={{ py:1.5, color:G.textMid, cursor:"pointer", borderRadius:"10px",
//                 "&:hover":{ background:`${G.gold2}15`, color:G.gold1 } }}
//               >Teams</ListItem>
//               <ListItem
//                 onClick={handleLoginClick} // Add click handler
//                 sx={{ py:1.5, color:G.textMid, cursor:"pointer", borderRadius:"10px",
//                 "&:hover":{ background:`${G.gold2}15`, color:G.gold1 } }}
//               >Log In</ListItem>
//             </List>
//             <Button
//               fullWidth
//               variant="contained"
//               onClick={handleSignUpClick} // Add click handler
//               sx={{
//                 mt:2, background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//                 color:"white", borderRadius:"10px", fontWeight:700,
//               }}
//             >
//               Sign Up Free
//             </Button>
//           </Box>
//         </Drawer>

//         {/* ── HERO ────────────────────────────────────────────────────────────── */}
//         <Box ref={featuresRef} sx={{
//           minHeight:"100vh", position:"relative",
//           display:"flex", alignItems:"center",
//           pt:14, pb:12, zIndex:1,
//           // Warm golden gradient background
//           background:`
//             radial-gradient(ellipse 80% 70% at 50% -10%, ${G.gold4}90 0%, ${G.gold5}60 35%, transparent 65%),
//             linear-gradient(180deg, ${G.gold5} 0%, ${G.pageBg} 60%)
//           `,
//           overflow:"hidden",
//         }}>

//           {/* Floating tool pills scattered in background */}
//           <FloatingToolPills/>

//           {/* Central glowing orb (like the purple sphere in reference) */}
//           <Box sx={{
//             position:"absolute",
//             left:"50%", top:"50%",
//             transform:"translate(-50%,-50%)",
//             width:{xs:180,md:280}, height:{xs:180,md:280},
//             borderRadius:"50%",
//             background:`radial-gradient(circle at 35% 35%, ${G.gold3}80, ${G.gold1}40, ${G.gold2}20)`,
//             boxShadow:`
//               0 0 80px ${G.gold3}50,
//               0 0 160px ${G.gold2}30,
//               inset 0 0 60px ${G.gold4}40
//             `,
//             opacity:0.35,
//             animation:"orbPulse 5s ease-in-out infinite",
//             "@keyframes orbPulse":{
//               "0%,100%":{ transform:"translate(-50%,-50%) scale(1)", opacity:0.35 },
//               "50%":    { transform:"translate(-50%,-50%) scale(1.08)", opacity:0.45 },
//             },
//             zIndex:2,
//             // Orbit rings
//             "&::before":{
//               content:'""', position:"absolute",
//               inset:"-20%", borderRadius:"50%",
//               border:`1.5px solid ${G.gold2}35`,
//               animation:"orbitRing1 8s linear infinite",
//               "@keyframes orbitRing1":{ "0%":{transform:"rotateX(70deg) rotateZ(0deg)"}, "100%":{transform:"rotateX(70deg) rotateZ(360deg)"} },
//             },
//             "&::after":{
//               content:'""', position:"absolute",
//               inset:"-50%", borderRadius:"50%",
//               border:`1px solid ${G.gold3}25`,
//               animation:"orbitRing2 12s linear infinite reverse",
//               "@keyframes orbitRing2":{ "0%":{transform:"rotateX(55deg) rotateZ(0deg)"}, "100%":{transform:"rotateX(55deg) rotateZ(360deg)"} },
//             },
//           }}/>

//           {/* Hero content */}
//           <Container maxWidth="md" sx={{ position:"relative", zIndex:12, textAlign:"center" }}>
//             {/* Badge */}
//             <Box sx={{
//               display:"inline-flex",alignItems:"center",gap:1.2,
//               px:3,py:1.2,mb:5,borderRadius:20,
//               background:"rgba(255,255,255,0.85)",
//               border:`1.5px solid ${G.gold3}70`,
//               backdropFilter:"blur(16px)",
//               boxShadow:`0 4px 24px ${G.gold2}30`,
//               animation:"hBadge 0.9s ease both",
//               "@keyframes hBadge":{ from:{opacity:0,transform:"translateY(-20px)"}, to:{opacity:1,transform:"translateY(0)"} },
//             }}>
//               <AutoAwesomeIcon sx={{ color:G.gold1, fontSize:16 }}/>
//               <Typography sx={{ color:G.gold1, fontWeight:700, fontSize:13 }}>
//                 27+ AI-Powered Tools · One Creative Suite
//               </Typography>
//             </Box>

//             {/* Headline */}
//             <Box sx={{
//               animation:"hRise 1s ease both",
//               "@keyframes hRise":{ from:{opacity:0,transform:"translateY(30px)"}, to:{opacity:1,transform:"translateY(0)"} },
//             }}>
//               <Typography sx={{
//                 fontSize:{xs:"3rem",sm:"4rem",md:"5.5rem",lg:"6.5rem"},
//                 fontWeight:900,lineHeight:1.05,fontFamily:"Sora",
//                 display:"block", color:G.textDark,
//               }}> Creative Suite</Typography>
//               <Typography sx={{
//                 fontSize:{xs:"3rem",sm:"4rem",md:"5.5rem",lg:"6.5rem"},
//                 fontWeight:900,lineHeight:1.05,fontFamily:"Sora",
//                 display:"block", mb:1,
//                 background:`linear-gradient(135deg, ${G.gold1} 0%, ${G.gold2} 40%, ${G.gold3} 70%, ${G.gold2} 100%)`,
//                 WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent",
//                 backgroundSize:"200% auto",
//                 animation:"shimmer 3s linear infinite",
//                 "@keyframes shimmer":{ "0%":{backgroundPosition:"0% center"}, "100%":{backgroundPosition:"200% center"} },
//               }}>Built For Makers.</Typography>
//             </Box>

//             <Typography sx={{
//               color:G.textMid, maxWidth:620, mx:"auto", mb:7,
//               fontWeight:400, lineHeight:1.8, fontSize:{xs:"1rem",md:"1.15rem"},
//               animation:"hRise 1s 0.2s ease both",
//             }}>
//               Write books, generate blogs, check grammar, build brands, create ads, translate, humanize AI text,
//               and collaborate on documents — all in one unified golden workspace.
//             </Typography>

//             {/* CTAs */}
//             <Box sx={{ display:"flex",gap:3,justifyContent:"center",flexWrap:"wrap",mb:9,animation:"hRise 1s 0.35s ease both" }}>
//               <Button
//                 size="large"
//                 variant="contained"
//                 onClick={handleTryFreeClick} // Add click handler for Try For Free
//                 sx={{
//                   background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//                   color:"white",
//                   borderRadius:"14px",px:5,py:2,fontSize:16.5,fontWeight:800,
//                   boxShadow:`0 8px 40px ${G.gold2}60`,
//                   "&:hover":{ boxShadow:`0 16px 64px ${G.gold2}80`, transform:"perspective(400px) rotateX(-5deg) translateY(-3px)" },
//                   transition:"all 0.35s cubic-bezier(0.23,1,0.32,1)",
//                 }}
//               >
//                 Try For Free →
//               </Button>
//               <Button size="large" startIcon={<PlayArrowIcon/>} onClick={()=>setDemoOpen(true)} sx={{
//                 color:G.gold1,
//                 borderRadius:"14px",px:4,py:2,fontSize:15.5,fontWeight:700,
//                 border:`2px solid ${G.gold2}60`,
//                 background:"rgba(255,255,255,0.8)",
//                 backdropFilter:"blur(12px)",
//                 "&:hover":{ background:`${G.gold4}90`, borderColor:G.gold1 },
//               }}>
//                 Watch Demo
//               </Button>
//             </Box>
//           </Container>
//         </Box>

//         {/* ── TOOLS SECTION ──────────────────────────────────────────────────── */}
//         <Box ref={toolsRef} sx={{ py:14, position:"relative", zIndex:1, background:G.pageBg }} id="tools">
//           <Container maxWidth="lg">
//             <SectionHeading
//               chip="ALL TOOLS"
//               chipColor={G.gold1}
//               title="Every Tool. Unique Experience."
//               sub="27+ AI tools across 5 categories — each category animates differently so every tool feels alive and intentional."
//             />

//             {/* Category buttons */}
//             <Box sx={{ mb:7, display:"flex", justifyContent:"center" }}>
//               <Box sx={{
//                 display:"flex", gap:1.5, flexWrap:"wrap", justifyContent:"center",
//                 background:"rgba(255,255,255,0.9)",
//                 border:`1.5px solid ${G.borderGold}`,
//                 borderRadius:"16px", p:1.2,
//                 boxShadow:`0 4px 24px ${G.gold2}20`,
//               }}>
//                 {CATEGORIES.map((cat,i)=>(
//                   <Button key={cat.label} onClick={()=>switchTab(i)} sx={{
//                     px:3, py:1.2, borderRadius:"10px", fontSize:13, fontWeight:700,
//                     background: activeTab===i
//                       ? `linear-gradient(135deg, ${cat.color}20, ${cat.color}08)`
//                       : "transparent",
//                     color: activeTab===i ? cat.color : G.textLight,
//                     border: activeTab===i ? `1.5px solid ${cat.color}55` : "1.5px solid transparent",
//                     boxShadow: activeTab===i ? `0 4px 16px ${cat.color}25` : "none",
//                     "&:hover":{ color:cat.color, background:`${cat.color}12` },
//                     transition:"all 0.3s ease",
//                   }}>{cat.label}</Button>
//                 ))}
//               </Box>
//             </Box>

//             {/* Cards */}
//             <Box key={tabKey}>
//               <Grid2 container spacing={3}>
//                 {catTools(CATEGORIES[activeTab].label).map((tool,i)=>(
//                   <Grid2 key={`${tabKey}-${tool.name}`} xs={12} sm={6} md={4} lg={3}>
//                     <ToolCard tool={tool} anim={CATEGORIES[activeTab].anim} idx={i}/>
//                   </Grid2>
//                 ))}
//               </Grid2>
//             </Box>
//           </Container>
//         </Box>

//         {/* ── ALL TOOLS QUICK-VIEW GRID ─────────────────────────────────────── */}
//         <Box sx={{ py:10, background:`linear-gradient(180deg, ${G.pageBg}, ${G.gold5}80, ${G.pageBg})`, position:"relative", zIndex:1 }}>
//           <Container maxWidth="lg">
//             <Typography variant="h5" fontWeight={800} sx={{
//               textAlign:"center", mb:6, letterSpacing:-0.5,
//               "& span":{
//                 background:`linear-gradient(90deg, ${G.gold1}, ${G.gold2})`,
//                 WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent",
//               },
//             }}>
//               All <span>27 Tools</span> at a Glance
//             </Typography>
//             <Grid2 container spacing={1.8}>
//               {ALL_TOOLS.map((tool,i)=>(
//                 <Grid2 key={tool.name} xs={6} sm={4} md={3} lg={2}>
//                   <Box sx={{
//                     display:"flex",flexDirection:"column",alignItems:"center",
//                     textAlign:"center",gap:1,px:1.5,py:2.5,
//                     background:"rgba(255,255,255,0.8)",
//                     border:`2px solid ${tool.color}28`,
//                     borderRadius:"14px", cursor:"pointer",
//                     boxShadow:"0 2px 10px rgba(0,0,0,0.04)",
//                     animation:`qIn 0.5s ${i*0.025}s ease both`,
//                     "@keyframes qIn":{ from:{opacity:0,transform:"scale(0.8) translateY(10px)"}, to:{opacity:1,transform:"scale(1) translateY(0)"} },
//                     "&:hover":{
//                       border:`1.5px solid ${tool.color}65`,
//                       background:`linear-gradient(145deg, ${tool.color}12, rgba(255,255,255,0.95))`,
//                       transform:"translateY(-4px) scale(1.04)",
//                       boxShadow:`0 12px 30px ${tool.color}25`,
//                     },
//                     transition:"all 0.28s ease",
//                   }}>
//                     <Box sx={{
//                       width:44,height:44,borderRadius:"12px",
//                       background:`linear-gradient(135deg, ${tool.color}22, ${tool.color}0A)`,
//                       border:`1.5px solid ${tool.color}40`,
//                       display:"flex",alignItems:"center",justifyContent:"center",
//                       color:tool.color, fontSize:22,
//                     }}>
//                       {tool.icon}
//                     </Box>
//                     <Typography sx={{ color:G.textDark, fontSize:11, fontWeight:700, lineHeight:1.3 }}>
//                       {tool.name}
//                     </Typography>
//                     <Box sx={{ display:"flex",alignItems:"center",gap:0.5 }}>
//                       <Box sx={{ width:6,height:6,borderRadius:"50%",background:tool.dot }}/>
//                       <Typography sx={{ color:G.textLight, fontSize:10 }}>{tool.cat}</Typography>
//                     </Box>
//                   </Box>
//                 </Grid2>
//               ))}
//             </Grid2>
//           </Container>
//         </Box>

//         {/* ── SMARTDESK FEATURE ─────────────────────────────────────────────── */}
//         <Box sx={{ py:14, position:"relative", zIndex:1, background:G.pageBg }}>
//           <Container maxWidth="lg">
//             <Grid2 container spacing={8} alignItems="center">
//               <Grid2 xs={12} md={6}>
//                 <Chip label="AI SMARTDESK" sx={{ mb:2, background:`${G.gold2}20`, color:G.gold1, fontWeight:700, border:`1px solid ${G.gold2}40` }}/>
//                 <Typography variant="h3" fontWeight={900} sx={{
//                   fontSize:{xs:"2rem",md:"2.8rem"},mb:3,lineHeight:1.2,
//                   background:`linear-gradient(135deg, ${G.textDark}, ${G.gold1})`,
//                   WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent",
//                 }}>Your Command Center for Every AI Tool</Typography>
//                 <Typography sx={{ color:G.textLight, mb:4, lineHeight:1.8, fontSize:"1.05rem" }}>
//                   SmartDesk is the unified hub where all 27 tools live side by side. Switch contexts in one click, track every AI session, and build end-to-end creative workflows without losing your place.
//                 </Typography>
//                 {["Unified dashboard across all tools","AI session history & auto-save","Cross-tool smart workflows","Real-time team collaboration"].map(f=>(
//                   <Box key={f} sx={{ display:"flex",alignItems:"center",gap:2,mb:2 }}>
//                     <CheckCircleIcon sx={{ color:G.gold1, fontSize:20 }}/>
//                     <Typography sx={{ color:G.textMid, fontWeight:500 }}>{f}</Typography>
//                   </Box>
//                 ))}
//                 <Button variant="contained" sx={{
//                   mt:3, background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//                   color:"white", borderRadius:"12px", px:4, py:1.5, fontWeight:700,
//                   "&:hover":{ transform:"translateY(-2px)", boxShadow:`0 12px 40px ${G.gold2}60` },
//                   transition:"all 0.2s",
//                 }}>Explore SmartDesk</Button>
//               </Grid2>
//               <Grid2 xs={12} md={6}>
//                 {/* 3D mockup */}
//                 <Box sx={{
//                   background:`linear-gradient(145deg, #FFFDF5, #FFF8E0)`,
//                   border:`1.5px solid ${G.borderGold}`,borderRadius:"22px",p:4,
//                   transform:"perspective(1200px) rotateY(-12deg) rotateX(5deg)",
//                   boxShadow:`40px 40px 100px rgba(180,140,20,0.12), 0 0 0 1px ${G.borderGold}`,
//                 }}>
//                   <Box sx={{ display:"flex",gap:1,mb:3 }}>
//                     {["#E74C3C","#F1C40F","#2ECC71"].map(c=><Box key={c} sx={{ width:12,height:12,borderRadius:"50%",background:c }}/>)}
//                     <Typography variant="caption" sx={{ ml:2, color:G.textLight, fontSize:11 }}>SmartDesk — Active</Typography>
//                   </Box>
//                   <Grid2 container spacing={1.5}>
//                     {ALL_TOOLS.slice(0,8).map((tool,i)=>(
//                       <Grid2 key={i} xs={6}>
//                         <Box sx={{
//                           p:1.5,borderRadius:"10px",
//                           background:`linear-gradient(135deg, ${tool.color}12, rgba(255,255,255,0.6))`,
//                           border:`1px solid ${tool.color}30`,
//                           display:"flex",alignItems:"center",gap:1.2,
//                           "&:hover":{ border:`1px solid ${tool.color}60`, background:`${tool.color}18` },
//                           transition:"all 0.2s",cursor:"pointer",
//                         }}>
//                           <Box sx={{ color:tool.color,display:"flex",fontSize:18 }}>{tool.icon}</Box>
//                           <Typography sx={{ color:G.textMid, fontSize:10.5, fontWeight:700, lineHeight:1.2 }}>
//                             {tool.name.replace("AI ","")}
//                           </Typography>
//                         </Box>
//                       </Grid2>
//                     ))}
//                   </Grid2>
//                   <Box sx={{ mt:3,p:2,borderRadius:"12px",background:`linear-gradient(135deg, ${G.gold4}80, ${G.gold5})`, border:`1px solid ${G.borderGold}` }}>
//                     <Typography variant="caption" sx={{ color:G.gold1, fontWeight:800 }}>✦ AI SUGGESTION</Typography>
//                     <Typography sx={{ color:G.textMid, mt:0.5, fontSize:12, lineHeight:1.6 }}>
//                       Continue your Brand Strategy doc — 73% complete. Est. 8 min to finish.
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Grid2>
//             </Grid2>
//           </Container>
//         </Box>

//         {/* ── SMART TEAMS ───────────────────────────────────────────────────── */}
//         <Box ref={teamsRef} sx={{ py:14, background:`linear-gradient(180deg, ${G.pageBg}, ${G.gold5}70, ${G.pageBg})`, position:"relative", zIndex:1 }}>
//           <Container maxWidth="lg">
//             <Grid2 container spacing={8} alignItems="center">
//               <Grid2 xs={12} md={6} sx={{ order:{xs:2,md:1} }}>
//                 <Box sx={{
//                   background:`linear-gradient(145deg, #FFFDF5, #FFF8E0)`,
//                   border:`1.5px solid ${G.sage}35`,borderRadius:"22px",p:4,
//                   transform:"perspective(1200px) rotateY(12deg) rotateX(5deg)",
//                   boxShadow:`-40px 40px 100px rgba(46,125,82,0.08), 0 0 0 1px ${G.borderSoft}`,
//                 }}>
//                   <Typography sx={{ color:G.sage, fontWeight:700, display:"block", mb:3, fontSize:12, letterSpacing:1 }}>▶ SMART TEAMS · 7 ONLINE</Typography>
//                   <Box sx={{ display:"flex",gap:0.5,mb:3 }}>
//                     {["A","L","M","J","+3"].map((n,i)=>(
//                       <Avatar key={i} sx={{
//                         width:34,height:34,fontSize:13,fontWeight:700,
//                         background:[G.gold4,`${G.sage}35`,`${G.sky}35`,`${G.coral}35`,"#F0E8D0"][i],
//                         color:[G.gold1,G.sage,G.sky,G.coral,G.textLight][i],
//                         border:`2px solid white`,ml:i>0?-0.5:0,
//                       }}>{n}</Avatar>
//                     ))}
//                   </Box>
//                   {["Amara editing Brand Strategy doc","AI suggested 4 improvements","Marcus approved Section 3","Document auto-saved · v14"].map((msg,i)=>(
//                     <Box key={i} sx={{ display:"flex",gap:2,mb:1.8,alignItems:"flex-start" }}>
//                       <Box sx={{ width:7,height:7,borderRadius:"50%",mt:0.7,flexShrink:0, background:[G.gold2,G.sage,G.sky,G.teal][i] }}/>
//                       <Typography sx={{ color:G.textMid, fontSize:13, lineHeight:1.4 }}>{msg}</Typography>
//                     </Box>
//                   ))}
//                   <Box sx={{ mt:3,height:5,borderRadius:3,background:G.borderSoft,overflow:"hidden" }}>
//                     <Box sx={{ height:"100%",width:"68%",background:`linear-gradient(90deg, ${G.gold1}, ${G.gold3})`,borderRadius:3 }}/>
//                   </Box>
//                   <Typography sx={{ color:G.textLight, fontSize:11, mt:0.8 }}>Document 68% complete</Typography>
//                 </Box>
//               </Grid2>
//               <Grid2 xs={12} md={6} sx={{ order:{xs:1,md:2} }}>
//                 <Chip label="SMART TEAMS" sx={{ mb:2, background:`${G.sage}18`, color:G.sage, fontWeight:700, border:`1px solid ${G.sage}35` }}/>
//                 <Typography variant="h3" fontWeight={900} sx={{
//                   fontSize:{xs:"2rem",md:"2.8rem"},mb:3,lineHeight:1.2,
//                   background:`linear-gradient(135deg, ${G.textDark}, ${G.gold1})`,
//                   WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent",
//                 }}>Collaborate With AI-Augmented Teams</Typography>
//                 <Typography sx={{ color:G.textLight, mb:4, lineHeight:1.8 }}>
//                   Smart Teams connects everyone with shared AI tools, real-time document collaboration, version history, and intelligent suggestions — all powered by Synthium's AI layer.
//                 </Typography>
//                 {["Real-time multi-user document editing","AI inline suggestions & auto-rewrites","Shared prompt & template libraries","Full version history & one-click rollback"].map(f=>(
//                   <Box key={f} sx={{ display:"flex",alignItems:"center",gap:2,mb:2 }}>
//                     <CheckCircleIcon sx={{ color:G.sage, fontSize:20 }}/>
//                     <Typography sx={{ color:G.textMid, fontWeight:500 }}>{f}</Typography>
//                   </Box>
//                 ))}
//               </Grid2>
//             </Grid2>
//           </Container>
//         </Box>

//         {/* ── PRICING ───────────────────────────────────────────────────────── */}
//         <Box ref={pricingRef} sx={{ py:14, position:"relative", zIndex:1, background:G.pageBg }} id="pricing">
//           <Container maxWidth="lg">
//             <SectionHeading chip="PRICING" chipColor={G.teal} title="Simple, Transparent Pricing" sub="Start free. Scale as you grow. Cancel anytime — no tricks."/>
//             <Grid2 container spacing={3} justifyContent="center">
//               {PRICING.map((plan)=>(
//                 <Grid2 key={plan.name} xs={12} sm={6} md={4}>
//                   <Card sx={{
//                     height:"100%",
//                     background: plan.hi
//                       ? `linear-gradient(145deg, #FFF9E8, #FFFDF5)`
//                       : "#FFFEF9",
//                     border: plan.hi
//                       ? `2px solid ${G.gold2}`
//                       : `1.5px solid ${G.borderSoft}`,
//                     borderRadius:"20px", p:1, position:"relative", overflow:"visible",
//                     transform: plan.hi ? "scale(1.05)" : "scale(1)",
//                     boxShadow: plan.hi ? `0 24px 80px ${G.gold2}35` : "0 4px 20px rgba(0,0,0,0.05)",
//                     "&:hover":{ transform: plan.hi ? "scale(1.07) translateY(-4px)" : "translateY(-4px)", boxShadow:`0 20px 60px ${G.gold2}30` },
//                     transition:"all 0.3s ease",
//                   }}>
//                     {plan.hi && (
//                       <Chip label="Most Popular" sx={{
//                         position:"absolute",top:-16,left:"50%",transform:"translateX(-50%)",
//                         background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//                         color:"white",fontWeight:700,fontSize:12,
//                       }}/>
//                     )}
//                     <CardContent sx={{ p:4 }}>
//                       <Typography variant="overline" sx={{ color: plan.hi ? G.gold1 : G.textLight, fontWeight:700, letterSpacing:2 }}>{plan.name}</Typography>
//                       <Box sx={{ display:"flex",alignItems:"flex-end",gap:1,my:2 }}>
//                         <Typography variant="h3" fontWeight={900} sx={{ color:G.textDark }}>${plan.price}</Typography>
//                         <Typography sx={{ color:G.textLight, mb:0.5 }}>/mo</Typography>
//                       </Box>
//                       <Divider sx={{ borderColor:G.borderSoft, mb:3 }}/>
//                       <Stack spacing={1.5} mb={4}>
//                         {plan.features.map(f=>(
//                           <Box key={f} sx={{ display:"flex",gap:1.5,alignItems:"center" }}>
//                             <CheckCircleIcon sx={{ fontSize:16, color: plan.hi ? G.gold1 : G.sage }}/>
//                             <Typography variant="body2" sx={{ color:G.textMid }}>{f}</Typography>
//                           </Box>
//                         ))}
//                       </Stack>
//                       <Button fullWidth sx={ plan.hi ? {
//                         background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//                         color:"white",borderRadius:"12px",py:1.5,fontWeight:700,fontSize:15,
//                         "&:hover":{ boxShadow:`0 8px 30px ${G.gold2}60` },
//                       }:{
//                         border:`1.5px solid ${G.borderGold}`,color:G.gold1,
//                         borderRadius:"12px",py:1.5,fontWeight:600,
//                         "&:hover":{ background:`${G.gold4}60`, borderColor:G.gold1 },
//                       }}>{plan.cta}</Button>
//                     </CardContent>
//                   </Card>
//                 </Grid2>
//               ))}
//             </Grid2>
//           </Container>
//         </Box>

//         {/* ── TESTIMONIALS ─────────────────────────────────────────────────── */}
//         <Box sx={{ py:12, position:"relative", zIndex:1, background:`linear-gradient(180deg,${G.pageBg},${G.gold5}60,${G.pageBg})` }}>
//           <Container maxWidth="lg">
//             <SectionHeading chip="REVIEWS" chipColor={G.rose} title="Loved by Makers Worldwide"/>
//             <Grid2 container spacing={3}>
//               {TESTIMONIALS.map((t)=>(
//                 <Grid2 key={t.name} xs={12} md={4}>
//                   <Card sx={{
//                     background:"#FFFEF9",
//                     border:`1.5px solid ${G.borderSoft}`,borderRadius:"20px",p:1,height:"100%",
//                     "&:hover":{ border:`1.5px solid ${G.borderGold}`, transform:"translateY(-5px)", boxShadow:`0 20px 56px ${G.gold2}22` },
//                     transition:"all 0.3s ease",
//                     boxShadow:"0 2px 12px rgba(0,0,0,0.05)",
//                   }}>
//                     <CardContent sx={{ p:4 }}>
//                       <Box sx={{ display:"flex",mb:2.5 }}>
//                         {Array(t.stars).fill(0).map((_,j)=><StarIcon key={j} sx={{ color:G.gold2, fontSize:18 }}/>)}
//                       </Box>
//                       <Typography sx={{ color:G.textMid, mb:3, lineHeight:1.8, fontStyle:"italic", fontSize:"0.93rem" }}>
//                         "{t.text}"
//                       </Typography>
//                       <Box sx={{ display:"flex",alignItems:"center",gap:2 }}>
//                         <Avatar sx={{ background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`, fontWeight:700, color:"white" }}>{t.av}</Avatar>
//                         <Box>
//                           <Typography sx={{ color:G.textDark, fontWeight:700 }} variant="body2">{t.name}</Typography>
//                           <Typography sx={{ color:G.textLight }} variant="caption">{t.role}</Typography>
//                         </Box>
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid2>
//               ))}
//             </Grid2>
//           </Container>
//         </Box>

//         {/* ── FINAL CTA ─────────────────────────────────────────────────────── */}
//         <Box sx={{ py:18, position:"relative", zIndex:1, textAlign:"center",
//           background:`linear-gradient(180deg, ${G.pageBg}, ${G.gold5}90)`,
//           overflow:"hidden",
//         }}>
//           {/* big golden glow */}
//           <Box sx={{
//             position:"absolute",inset:0,
//             background:`radial-gradient(ellipse 70% 60% at 50% 100%, ${G.gold3}35 0%, transparent 65%)`,
//           }}/>
//           <Container maxWidth="md" sx={{ position:"relative" }}>
//             <Typography variant="h2" fontWeight={900} sx={{
//               fontSize:{xs:"2.2rem",md:"4.2rem"},mb:3,lineHeight:1.08,
//               background:`linear-gradient(135deg, ${G.textDark} 0%, ${G.gold1} 50%, ${G.gold3} 100%)`,
//               WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent",
//             }}>Ready to Create Without Limits?</Typography>
//             <Typography sx={{ color:G.textMid, mb:7, fontSize:"1.2rem", maxWidth:520, mx:"auto", lineHeight:1.7 }}>
//               Join 50,000+ creators, writers, and teams already building with Synthium.
//             </Typography>
//             <Box sx={{ display:"flex",gap:3,justifyContent:"center",flexWrap:"wrap" }}>
//               <Button
//                 size="large"
//                 variant="contained"
//                 onClick={handleTryFreeClick} // Add click handler for final CTA
//                 sx={{
//                   background:`linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
//                   color:"white",borderRadius:"14px",px:6,py:2,fontSize:18,fontWeight:800,
//                   animation:"ctaGlow 2.5s ease-in-out infinite",
//                   "@keyframes ctaGlow":{
//                     "0%,100%":{ boxShadow:`0 10px 60px ${G.gold2}60` },
//                     "50%":{ boxShadow:`0 14px 80px ${G.gold3}80` },
//                   },
//                   "&:hover":{ transform:"translateY(-3px) scale(1.03)" },
//                   transition:"transform 0.2s",
//                 }}
//               >
//                 Start Free — No Card Needed
//               </Button>
//               <Button size="large" startIcon={<PlayArrowIcon/>} onClick={()=>setDemoOpen(true)} sx={{
//                 color:G.gold1,borderRadius:"14px",px:4,py:2,fontSize:16,fontWeight:700,
//                 border:`2px solid ${G.gold2}60`,
//                 background:"rgba(255,255,255,0.8)",
//                 "&:hover":{ background:G.gold5, borderColor:G.gold1 },
//               }}>Watch Demo</Button>
//             </Box>
//           </Container>
//         </Box>

//         {/* ── FOOTER ────────────────────────────────────────────────────────── */}
//         <Box sx={{ borderTop:`1.5px solid ${G.borderGold}`, py:7, position:"relative", zIndex:1, background:G.cardBg }}>
//           <Container maxWidth="lg">
//             <Grid2 container spacing={4}>
//               <Grid2 xs={12} md={4}>
//                 <Box sx={{ display:"flex",alignItems:"center",gap:1.5,mb:2 }}>
//                   <Box
//                     component="img"
//                     src={synlogo}
//                     alt="Synthium Logo"
//                     sx={{
//                       width: 36,
//                       height: 36,
//                       objectFit: "contain",
//                     }}
//                   />
//                   <Box>
//                     <Typography sx={styles.footerLogoTitle}>SYNTHIUM</Typography>
//                     <Typography sx={styles.footerLogoSubtitle}>Creative Suite</Typography>
//                   </Box>
//                 </Box>
//                 <Typography sx={{ color:G.textLight, lineHeight:1.75, fontSize:14 }}>
//                   The complete AI Creative Suite for writers, creators, and teams who build without limits.
//                 </Typography>
//               </Grid2>
//               <Grid2 xs={12} md={8}>
//                 <Box sx={{ display:"flex",gap:6,flexWrap:"wrap",justifyContent:{md:"flex-end"} }}>
//                   {["Product","Company","Legal","Support"].map(s=>(
//                     <Box key={s}>
//                       <Typography variant="caption" sx={{ color:G.textLight, fontWeight:700, letterSpacing:1.5, display:"block", mb:2 }}>
//                         {s.toUpperCase()}
//                       </Typography>
//                       {["Overview","Docs","Contact"].map(l=>(
//                         <Typography key={l} variant="caption" sx={{
//                           display:"block",mb:1.2,cursor:"pointer",color:G.textLight,
//                           "&:hover":{color:G.gold1}, transition:"color 0.2s",
//                         }}>{l}</Typography>
//                       ))}
//                     </Box>
//                   ))}
//                 </Box>
//               </Grid2>
//             </Grid2>
//             <Divider sx={{ my:5, borderColor:G.borderSoft }}/>
//             <Box sx={{ display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:2 }}>
//               <Typography variant="caption" sx={{ color:G.textLight }}>© 2026 Synthium Creative Suite. All rights reserved.</Typography>
//               <Typography variant="caption" sx={{ color:G.textLight }}>Built with ✦ for creators everywhere</Typography>
//             </Box>
//           </Container>
//         </Box>

//         <DemoModal open={demoOpen} onClose={()=>setDemoOpen(false)}/>
//       </Box>
//     </ThemeProvider>
//   );
// }


import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom"; // Add this import
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  Typography,
  Container,
  Chip,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  Avatar,
  Divider,
  Stack,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import TranslateIcon from "@mui/icons-material/Translate";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import PolicyIcon from "@mui/icons-material/Policy";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import BusinessIcon from "@mui/icons-material/Business";
import CampaignIcon from "@mui/icons-material/Campaign";
import PsychologyIcon from "@mui/icons-material/Psychology";
import DeskIcon from "@mui/icons-material/Desk";
import ImageIcon from "@mui/icons-material/Image";
import SummarizeIcon from "@mui/icons-material/Summarize";
import GroupsIcon from "@mui/icons-material/Groups";
import DescriptionIcon from "@mui/icons-material/Description";
import ShareIcon from "@mui/icons-material/Share";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import GoogleIcon from "@mui/icons-material/Google";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import BrushIcon from "@mui/icons-material/Brush";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FacebookIcon from "@mui/icons-material/Facebook"; // Add Facebook icon

// Import auth service (adjust the path as needed)
import auth from "../../services/authService"; // Add this import

// Import logo (make sure to add your logo file to the project)
import synlogo from "../../static/POET_Logo_Pen.png"; // Adjust the path as needed

// ─── THEME: White + Golden ────────────────────────────────────────────────────
const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#B8860B" },
    secondary: { main: "#D4A017" },
    background: { default: "#FDFAF4", paper: "#FFFEF9" },
    text: { primary: "#2C2410", secondary: "#6B5A3A" },
  },
  typography: { fontFamily: "'Sora', 'DM Sans', sans-serif" },
});

// ─── COLOR TOKENS ─────────────────────────────────────────────────────────────
const G = {
  // Backgrounds
  pageBg: "#FDFAF4",
  cardBg: "#FFFEF9",
  cardBg2: "#FFF8E8",
  heroTop: "#FFFDF5",
  // Golds
  gold1: "#B8860B", // dark gold
  gold2: "#D4A017", // mid gold
  gold3: "#F0C040", // bright gold
  gold4: "#FAE08A", // pale gold
  gold5: "#FFF8DC", // cream
  // Accent colors for tools (jewel on white)
  sky: "#1E7DB8", // blue
  sage: "#2E7D52",
  lavender: "#6A4FAB",
  coral: "#C0392B",
  rose: "#A0395A",
  teal: "#0E8585",
  amber: "#B8860B",
  // Text
  textDark: "#1A1205",
  textMid: "#4A3A1A",
  textLight: "#8A7350",
  textBlack: "#000000", // Added pure black for subtitle
  // Borders
  borderGold: "#E8CC80",
  borderSoft: "#F0E4C0",
};

// ─── ALL 27 TOOLS ─────────────────────────────────────────────────────────────
const ALL_TOOLS = [
  {
    icon: <TranslateIcon />,
    name: "Smart Translator",
    desc: "100+ languages, deep context AI",
    color: G.sky,
    cat: "Language",
    dot: "#1E7DB8",
  },
  {
    icon: <SpellcheckIcon />,
    name: "Grammar Check",
    desc: "Semantic grammar & style correction",
    color: G.sage,
    cat: "Language",
    dot: "#2E7D52",
  },
  {
    icon: <FindReplaceIcon />,
    name: "AI Paraphraser",
    desc: "Rephrase preserving your voice",
    color: G.lavender,
    cat: "Language",
    dot: "#6A4FAB",
  },
  {
    icon: <PolicyIcon />,
    name: "AI Plagiarism Checker",
    desc: "Instant originality detection",
    color: G.coral,
    cat: "Language",
    dot: "#C0392B",
  },
  {
    icon: <FormatQuoteIcon />,
    name: "AI Citation Generator",
    desc: "APA, MLA, Chicago & more",
    color: G.rose,
    cat: "Language",
    dot: "#A0395A",
  },
  {
    icon: <SummarizeIcon />,
    name: "AI Summarizer",
    desc: "Condense content intelligently",
    color: G.teal,
    cat: "Language",
    dot: "#0E8585",
  },
  {
    icon: <PsychologyIcon />,
    name: "AI Humanizer",
    desc: "Make AI text sound human",
    color: G.amber,
    cat: "Language",
    dot: "#B8860B",
  },
  {
    icon: <AutoStoriesIcon />,
    name: "AI Book Writing Tool",
    desc: "Ideas · Outline · Cover · Summary",
    color: G.gold2,
    cat: "Content",
    dot: "#D4A017",
  },
  {
    icon: <LibraryBooksIcon />,
    name: "Book Outline Builder",
    desc: "Structure every chapter precisely",
    color: G.amber,
    cat: "Content",
    dot: "#B8860B",
  },
  {
    icon: <FormatAlignLeftIcon />,
    name: "Book Summary AI",
    desc: "Generate compelling blurbs fast",
    color: G.sage,
    cat: "Content",
    dot: "#2E7D52",
  },
  {
    icon: <BrushIcon />,
    name: "Cover Ideas Generator",
    desc: "Visual concepts for your cover",
    color: G.rose,
    cat: "Content",
    dot: "#A0395A",
  },
  {
    icon: <RssFeedIcon />,
    name: "AI Blog Generator",
    desc: "SEO-ready articles in seconds",
    color: G.teal,
    cat: "Content",
    dot: "#0E8585",
  },
  {
    icon: <BusinessIcon />,
    name: "AI Business Tools",
    desc: "Slogan · Strategy · Ideas · Persona",
    color: G.sky,
    cat: "Business",
    dot: "#1E7DB8",
  },
  {
    icon: <RecordVoiceOverIcon />,
    name: "Slogan Generator",
    desc: "Memorable taglines instantly",
    color: G.coral,
    cat: "Business",
    dot: "#C0392B",
  },
  {
    icon: <AutoAwesomeIcon />,
    name: "Brand Strategy AI",
    desc: "Positioning, voice & identity",
    color: G.lavender,
    cat: "Business",
    dot: "#6A4FAB",
  },
  {
    icon: <EmojiObjectsIcon />,
    name: "Business Idea Generator",
    desc: "Validated ideas for your venture",
    color: G.gold2,
    cat: "Business",
    dot: "#D4A017",
  },
  {
    icon: <PersonSearchIcon />,
    name: "Persona Generator",
    desc: "Detailed buyer personas at scale",
    color: G.amber,
    cat: "Business",
    dot: "#B8860B",
  },
  {
    icon: <InstagramIcon />,
    name: "Instagram Ads AI",
    desc: "Scroll-stopping ad copy",
    color: G.rose,
    cat: "Ads",
    dot: "#A0395A",
  },
  {
    icon: <LinkedInIcon />,
    name: "LinkedIn Ads AI",
    desc: "Professional ad copy that converts",
    color: G.sky,
    cat: "Ads",
    dot: "#1E7DB8",
  },
  {
    icon: <TwitterIcon />,
    name: "Twitter / X Ads",
    desc: "Short-form ads that drive clicks",
    color: G.lavender,
    cat: "Ads",
    dot: "#6A4FAB",
  },
  {
    icon: <GoogleIcon />,
    name: "Google Ads AI",
    desc: "Headlines & descriptions that rank",
    color: G.teal,
    cat: "Ads",
    dot: "#0E8585",
  },
  {
    icon: <CampaignIcon />,
    name: "AI Advertising Tool",
    desc: "Cross-platform ad campaigns",
    color: G.coral,
    cat: "Ads",
    dot: "#C0392B",
  },
  {
    icon: <DeskIcon />,
    name: "AI SmartDesk",
    desc: "All-in-one AI workspace hub",
    color: G.gold2,
    cat: "Workspace",
    dot: "#D4A017",
  },
  {
    icon: <ImageIcon />,
    name: "AI Image Generator",
    desc: "Stunning visuals from text",
    color: G.sky,
    cat: "Workspace",
    dot: "#1E7DB8",
  },
  {
    icon: <GroupsIcon />,
    name: "Smart Teams",
    desc: "Collaborate with AI assistance",
    color: G.sage,
    cat: "Workspace",
    dot: "#2E7D52",
  },
  {
    icon: <DescriptionIcon />,
    name: "Smart Doc Creation",
    desc: "AI drafts your documents",
    color: G.teal,
    cat: "Workspace",
    dot: "#0E8585",
  },
  {
    icon: <ShareIcon />,
    name: "Smart Doc Collaboration",
    desc: "Real-time AI-powered co-editing",
    color: G.lavender,
    cat: "Workspace",
    dot: "#6A4FAB",
  },
];

// floating positions for each tool pill in the hero (x%, y%, scale, delay, duration)
const FLOAT_CONFIG = [
  { x: 3, y: 10, s: 1.0, d: 0.0, dur: 6.0 },
  { x: 72, y: 5, s: 0.9, d: 1.2, dur: 7.5 },
  { x: 85, y: 18, s: 1.05, d: 0.5, dur: 5.8 },
  { x: 10, y: 30, s: 0.85, d: 2.0, dur: 8.0 },
  { x: 60, y: 28, s: 0.95, d: 0.8, dur: 6.5 },
  { x: 88, y: 42, s: 0.8, d: 1.5, dur: 7.0 },
  { x: 5, y: 52, s: 1.0, d: 0.3, dur: 5.5 },
  { x: 75, y: 55, s: 0.88, d: 2.5, dur: 8.5 },
  { x: 42, y: 62, s: 0.92, d: 1.0, dur: 6.8 },
  { x: 15, y: 72, s: 0.96, d: 1.8, dur: 7.2 },
  { x: 82, y: 72, s: 0.84, d: 0.6, dur: 6.2 },
  { x: 35, y: 80, s: 1.02, d: 2.2, dur: 5.9 },
  { x: 60, y: 85, s: 0.9, d: 0.9, dur: 7.8 },
  { x: 7, y: 88, s: 0.82, d: 1.4, dur: 8.2 },
  { x: 90, y: 88, s: 0.95, d: 0.2, dur: 6.6 },
  { x: 48, y: 8, s: 0.88, d: 1.7, dur: 7.4 },
  { x: 25, y: 18, s: 1.0, d: 0.4, dur: 5.7 },
  { x: 55, y: 48, s: 0.93, d: 2.1, dur: 8.1 },
  { x: 20, y: 45, s: 0.86, d: 1.1, dur: 6.9 },
  { x: 70, y: 38, s: 0.97, d: 1.6, dur: 7.6 },
  { x: 32, y: 35, s: 0.91, d: 0.7, dur: 5.6 },
  { x: 78, y: 25, s: 0.83, d: 2.3, dur: 8.3 },
  { x: 50, y: 70, s: 1.01, d: 1.3, dur: 6.4 },
  { x: 12, y: 60, s: 0.87, d: 0.1, dur: 7.9 },
  { x: 65, y: 15, s: 0.94, d: 1.9, dur: 6.1 },
  { x: 40, y: 92, s: 0.89, d: 2.4, dur: 7.3 },
  { x: 22, y: 95, s: 0.96, d: 0.5, dur: 5.4 },
];

// ─── CATEGORIES ───────────────────────────────────────────────────────────────
const CATEGORIES = [
  { label: "Language & Writing", color: G.sky, anim: "flipY" },
  { label: "Content Creation", color: G.gold2, anim: "zoomSpin" },
  { label: "Business & Brand", color: G.teal, anim: "slideUp" },
  { label: "Advertising", color: G.coral, anim: "dropBounce" },
  { label: "Workspace", color: G.lavender, anim: "swingDown" },
];

const PRICING = [
  {
    name: "Starter",
    price: "0",
    features: [
      "5 tools access",
      "100 AI credits/mo",
      "Basic support",
      "1 workspace",
    ],
    cta: "Get Started Free",
    hi: false,
  },
  {
    name: "Pro",
    price: "19",
    features: [
      "All 27+ tools",
      "5,000 AI credits/mo",
      "Priority support",
      "5 workspaces",
      "Team collaboration",
      "Advanced export",
    ],
    cta: "Start Pro Trial",
    hi: true,
  },
  {
    name: "Enterprise",
    price: "79",
    features: [
      "Unlimited tools",
      "Unlimited AI credits",
      "24/7 dedicated support",
      "Unlimited workspaces",
      "Custom AI training",
      "API access",
      "SSO",
    ],
    cta: "Contact Sales",
    hi: false,
  },
];

const TESTIMONIALS = [
  {
    name: "Amara Osei",
    role: "Content Director",
    av: "A",
    text: "Synthium replaced 6 different tools. My team's output tripled in the first month.",
    stars: 5,
  },
  {
    name: "Lena Kovač",
    role: "Solo Founder",
    av: "L",
    text: "The AI Business Tools helped me launch my brand in days, not months. Absolutely unreal.",
    stars: 5,
  },
  {
    name: "Marcus Tran",
    role: "Novel Author",
    av: "M",
    text: "The Book Writing Tool understood my genre, voice, and plot — like having a co-author.",
    stars: 5,
  },
];

// Styles object for custom styling
const styles = {
  logoTitle: {
    fontSize: "16px",
    fontWeight: 900,
    color: "rgb(47, 62, 226)", // Blue color for title (same for header and footer)
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
  },
  logoSubtitle: {
    fontSize: "9px",
    color: "#000000", // Black color for subtitle (same for header and footer)
    letterSpacing: "1px",
    fontWeight: 600,
    textTransform: "uppercase",
  },
  footerLogoTitle: {
    fontSize: "18px",
    fontWeight: 900,
    color: "rgb(47, 62, 226)", // Blue color for title (matching header)
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
  },
  footerLogoSubtitle: {
    fontSize: "10px",
    color: "#000000", // Black color for subtitle (matching header)
    letterSpacing: "1px",
    fontWeight: 600,
    textTransform: "uppercase",
  },
  // Add black text style for navigation items
  navText: {
    color: "#000000",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    "&:hover": { color: G.gold1 },
    transition: "color 0.2s",
  },
  footerContactText: {
    color: G.textMid,
    fontSize: 13,
    lineHeight: 1.8,
    display: "block",
    mb: 1,
  },
  footerContactLink: {
    color: G.textMid,
    fontSize: 13,
    textDecoration: "none",
    display: "block",
    mb: 1,
    "&:hover": {
      color: G.gold1,
    },
    transition: "color 0.2s",
  },
  socialIcon: {
    color: G.textMid,
    fontSize: 20,
    "&:hover": {
      color: G.gold1,
      transform: "translateY(-2px)",
    },
    transition: "all 0.2s",
  },
};

// ─── FLOATING TOOL PILLS (hero background, like the reference image) ──────────
function FloatingToolPills() {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 1,
        overflow: "hidden",
      }}
    >
      {/* Soft radial vignette so pills don't compete with hero text */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 10,
          background: `
          radial-gradient(ellipse 68% 60% at 50% 50%, rgba(253,250,244,0.92) 18%, rgba(253,250,244,0.55) 55%, transparent 80%),
          linear-gradient(to bottom, rgba(253,250,244,0.98) 0%, rgba(253,250,244,0.3) 20%, rgba(253,250,244,0.3) 80%, rgba(253,250,244,0.98) 100%)
        `,
        }}
      />

      {ALL_TOOLS.map((tool, i) => {
        const cfg = FLOAT_CONFIG[i] || { x: 50, y: 50, s: 1, d: 0, dur: 7 };
        const animName = `float_${i}`;
        // Each pill gets a slightly different float path
        const yAmt = 14 + (i % 5) * 4;
        const xAmt = ((i % 3) - 1) * 6;
        const rot = (i % 2 === 0 ? 1 : -1) * (1 + (i % 3));

        return (
          <Box
            key={tool.name}
            sx={{
              position: "absolute",
              left: `${cfg.x}%`,
              top: `${cfg.y}%`,
              transform: `scale(${cfg.s})`,
              transformOrigin: "center center",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              px: "14px",
              py: "9px",
              background: `linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,252,235,0.88))`,
              backdropFilter: "blur(12px)",
              border: `1.5px solid ${tool.color}45`,
              borderRadius: "40px",
              boxShadow: `
                0 4px 20px rgba(0,0,0,0.08),
                0 1px 4px rgba(0,0,0,0.06),
                inset 0 1px 0 rgba(255,255,255,0.9),
                0 0 0 1px ${tool.color}18
              `,
              whiteSpace: "nowrap",
              animation: `${animName} ${cfg.dur}s ease-in-out ${cfg.d}s infinite`,
              [`@keyframes ${animName}`]: {
                "0%,100%": {
                  transform: `scale(${cfg.s}) translate(0px,0px) rotate(0deg)`,
                },
                "33%": {
                  transform: `scale(${cfg.s}) translate(${xAmt}px,-${yAmt * 0.6}px) rotate(${rot * 0.5}deg)`,
                },
                "66%": {
                  transform: `scale(${cfg.s}) translate(${-xAmt * 0.5}px,-${yAmt}px) rotate(${rot}deg)`,
                },
              },
            }}
          >
            {/* Colored dot like the reference image */}
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: tool.dot,
                flexShrink: 0,
                boxShadow: `0 0 6px ${tool.dot}80`,
              }}
            />
            <Typography
              sx={{
                fontSize: 12.5,
                fontWeight: 700,
                color: G.textDark,
                letterSpacing: 0.2,
              }}
            >
              {tool.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

// ─── ANIMATED TOOL CARD (5 unique animations) ─────────────────────────────────
function ToolCard({ tool, anim, idx }) {
  const [hovered, setHovered] = useState(false);
  const c = tool.color;

  const variants = {
    flipY: {
      entrance: `tflipY 0.65s cubic-bezier(0.23,1,0.32,1) ${idx * 0.07}s both`,
      kf: {
        "@keyframes tflipY": {
          "0%": {
            opacity: 0,
            transform: "perspective(700px) rotateY(-90deg) scale(0.85)",
          },
          "100%": {
            opacity: 1,
            transform: "perspective(700px) rotateY(0deg) scale(1)",
          },
        },
      },
      hover: "perspective(900px) rotateY(8deg) rotateX(-4deg) translateY(-8px)",
    },
    zoomSpin: {
      entrance: `tzoomSpin 0.7s cubic-bezier(0.34,1.56,0.64,1) ${idx * 0.09}s both`,
      kf: {
        "@keyframes tzoomSpin": {
          "0%": { opacity: 0, transform: "scale(0.1) rotate(-240deg)" },
          "100%": { opacity: 1, transform: "scale(1) rotate(0deg)" },
        },
      },
      hover: "scale(1.07) rotate(1.5deg) translateY(-7px)",
    },
    slideUp: {
      entrance: `tslideUp 0.6s cubic-bezier(0.23,1,0.32,1) ${idx * 0.08}s both`,
      kf: {
        "@keyframes tslideUp": {
          "0%": { opacity: 0, transform: "translateY(50px) skewY(4deg)" },
          "70%": { transform: "translateY(-6px) skewY(-1deg)" },
          "100%": { opacity: 1, transform: "translateY(0) skewY(0)" },
        },
      },
      hover: "perspective(700px) rotateX(-8deg) translateY(-8px)",
    },
    dropBounce: {
      entrance: `tdropBounce 0.8s cubic-bezier(0.34,1.4,0.64,1) ${idx * 0.06}s both`,
      kf: {
        "@keyframes tdropBounce": {
          "0%": { opacity: 0, transform: "translateY(-60px) scaleY(1.4)" },
          "55%": { transform: "translateY(10px) scaleY(0.88)" },
          "80%": { transform: "translateY(-4px) scaleY(1.03)" },
          "100%": { opacity: 1, transform: "translateY(0) scaleY(1)" },
        },
      },
      hover: "translateY(-10px) scale(1.05) perspective(600px) rotateX(5deg)",
    },
    swingDown: {
      entrance: `tswingDown 0.85s cubic-bezier(0.23,1,0.32,1) ${idx * 0.08}s both`,
      kf: {
        "@keyframes tswingDown": {
          "0%": {
            opacity: 0,
            transform: "perspective(700px) rotateX(80deg)",
            transformOrigin: "top center",
          },
          "70%": {
            transform: "perspective(700px) rotateX(-5deg)",
            transformOrigin: "top center",
          },
          "100%": {
            opacity: 1,
            transform: "perspective(700px) rotateX(0deg)",
            transformOrigin: "top center",
          },
        },
      },
      hover: "perspective(800px) rotateX(-7deg) rotateY(5deg) translateY(-7px)",
    },
  };

  const v = variants[anim] || variants.flipY;

  return (
    <Card
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        background: hovered
          ? `linear-gradient(145deg, ${c}12, ${c}05, #FFFEF9)`
          : "#FFFEF9",
        border: `1.5px solid ${hovered ? c + "70" : G.borderSoft}`,
        borderRadius: "18px",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        transform: hovered ? v.hover : "none",
        transition: "all 0.42s cubic-bezier(0.23,1,0.32,1)",
        boxShadow: hovered
          ? `0 24px 60px ${c}25, 0 4px 16px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,1)`
          : "0 2px 12px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
        opacity: 0,
        animation: v.entrance,
        ...v.kf,
        height: "100%",
      }}
    >
      {/* Top shimmer */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "2.5px",
          background: `linear-gradient(90deg, transparent, ${c}, transparent)`,
          opacity: hovered ? 1 : 0,
          transition: "opacity 0.35s",
        }}
      />
      {/* Glow corner */}
      <Box
        sx={{
          position: "absolute",
          top: -30,
          right: -30,
          width: 110,
          height: 110,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${c}28, transparent 70%)`,
          filter: "blur(20px)",
          opacity: hovered ? 1 : 0,
          transition: "opacity 0.5s",
        }}
      />

      <CardContent sx={{ p: 3, position: "relative", zIndex: 1 }}>
        {/* Icon */}
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: "14px",
            mb: 2.5,
            background: hovered
              ? `linear-gradient(135deg, ${c}25, ${c}0E)`
              : `linear-gradient(135deg, ${c}18, ${c}08)`,
            border: `1.5px solid ${c}35`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: c,
            fontSize: 24,
            boxShadow: hovered ? `0 0 20px ${c}45` : "none",
            transform: hovered
              ? "scale(1.15) rotateZ(-7deg)"
              : "scale(1) rotateZ(0deg)",
            transition: "all 0.4s cubic-bezier(0.34,1.56,0.64,1)",
          }}
        >
          {tool.icon}
        </Box>

        <Typography
          variant="subtitle1"
          fontWeight={800}
          sx={{ color: G.textDark, mb: 0.8, fontSize: 14.5, lineHeight: 1.3 }}
        >
          {tool.name}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: G.textLight, lineHeight: 1.65, fontSize: 12.5 }}
        >
          {tool.desc}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            mt: 2.5,
            opacity: hovered ? 1 : 0,
            transform: hovered ? "translateX(0)" : "translateX(-12px)",
            transition: "all 0.32s cubic-bezier(0.23,1,0.32,1)",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: c, fontWeight: 800, fontSize: 12 }}
          >
            Launch
          </Typography>
          <ArrowForwardIcon sx={{ fontSize: 14, color: c }} />
        </Box>
      </CardContent>
    </Card>
  );
}

// ─── DEMO MODAL ───────────────────────────────────────────────────────────────
function DemoModal({ open, onClose }) {
  if (!open) return null;
  return (
    <Box
      onClick={onClose}
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(20,14,4,0.75)",
        backdropFilter: "blur(14px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: "mFade 0.3s ease both",
        "@keyframes mFade": { from: { opacity: 0 }, to: { opacity: 1 } },
      }}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          width: { xs: "95vw", md: "72vw" },
          maxWidth: 920,
          background: "#FFFEF9",
          border: `1.5px solid ${G.borderGold}`,
          borderRadius: "20px",
          p: 4,
          position: "relative",
          boxShadow: "0 32px 100px rgba(0,0,0,0.18)",
          animation: "mScale 0.4s cubic-bezier(0.23,1,0.32,1) both",
          "@keyframes mScale": {
            from: { transform: "scale(0.82)", opacity: 0 },
            to: { transform: "scale(1)", opacity: 1 },
          },
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 14, right: 14, color: G.textLight }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h4"
          fontWeight={900}
          sx={{ color: G.textDark, mb: 0.5 }}
        >
          See Synthium in Action
        </Typography>
        <Typography sx={{ color: G.textLight, mb: 4 }}>
          A 2-minute tour of the full creative suite
        </Typography>
        <Box
          sx={{
            width: "100%",
            aspectRatio: "16/9",
            background: `linear-gradient(135deg, ${G.gold5}, #FFF9E0)`,
            borderRadius: "12px",
            border: `1.5px solid ${G.borderGold}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: `0 0 0 12px ${G.gold3}30, 0 0 60px ${G.gold1}60`,
              animation: "mpulse 2s ease-in-out infinite",
              "@keyframes mpulse": {
                "0%,100%": { transform: "scale(1)" },
                "50%": { transform: "scale(1.09)" },
              },
            }}
          >
            <PlayArrowIcon sx={{ fontSize: 42, color: "white" }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function SynthiumLanding() {
  const history = useHistory(); // Add this hook
  const [activeTab, setActiveTab] = useState(0);
  const [demoOpen, setDemoOpen] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [tabKey, setTabKey] = useState(0);

  // Refs for navigation
  const featuresRef = useRef(null);
  const toolsRef = useRef(null);
  const pricingRef = useRef(null);
  const teamsRef = useRef(null);

  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700;800;900&family=DM+Sans:wght@400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    const fn = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  // Navigation handlers
  const handleLoginClick = () => {
    localStorage.removeItem("is_guest");
    localStorage.removeItem("guest_id");
    localStorage.removeItem("guest_user");
    history.push("/login");
  };

  const handleSignUpClick = () => {
    history.push("/signup");
  };

  const handleTryFreeClick = async () => {
    try {
      await auth.guestLogin();
      window.location.href = "/docTags";
    } catch (error) {
      console.error("Guest login failed", error);
      // Optionally show an error message to the user
    }
  };

  const switchTab = (i) => {
    setActiveTab(i);
    setTabKey((k) => k + 1);
  };

  // Navigation function
  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setDrawer(false); // Close mobile drawer after navigation
  };

  const catTools = (cat) =>
    ALL_TOOLS.filter((t) => {
      if (cat === "Language & Writing") return t.cat === "Language";
      if (cat === "Content Creation") return t.cat === "Content";
      if (cat === "Business & Brand") return t.cat === "Business";
      if (cat === "Advertising") return t.cat === "Ads";
      if (cat === "Workspace") return t.cat === "Workspace";
      return false;
    });

  /* Shared section heading */
  const SectionHeading = ({ chip, chipColor, title, sub }) => (
    <Box sx={{ textAlign: "center", mb: 8 }}>
      <Chip
        label={chip}
        sx={{
          mb: 2,
          background: `${chipColor}15`,
          color: chipColor,
          fontWeight: 700,
          letterSpacing: 2,
          border: `1px solid ${chipColor}35`,
          fontSize: 12,
        }}
      />
      <Typography
        variant="h2"
        fontWeight={900}
        sx={{
          fontSize: { xs: "2rem", md: "3.3rem" },
          mb: 2,
          lineHeight: 1.15,
          background: `linear-gradient(135deg, ${G.textDark} 0%, ${G.gold1} 60%, ${G.gold2} 100%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {title}
      </Typography>
      {sub && (
        <Typography
          sx={{
            color: G.textLight,
            maxWidth: 580,
            mx: "auto",
            fontSize: "1.05rem",
            lineHeight: 1.75,
          }}
        >
          {sub}
        </Typography>
      )}
    </Box>
  );

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          background: G.pageBg,
          minHeight: "100vh",
          overflowX: "hidden",
          fontFamily: "'Sora','DM Sans',sans-serif",
        }}
      >
        {/* Very subtle gold dot texture */}
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            pointerEvents: "none",
            zIndex: 0,
            backgroundImage: `radial-gradient(circle, ${G.gold3}22 1px, transparent 1px)`,
            backgroundSize: "52px 52px",
          }}
        />
        <AppBar
          elevation={0}
          sx={{
            background: G.pageBg,
            backdropFilter: "blur(20px)",
            borderBottom: `2px solid ${G.gold2}`,
            boxShadow: `0 2px 8px ${G.gold2}20`,
            transition: "all 0.35s ease",
            zIndex: 100,
          }}
        >
          <Toolbar
            sx={{
              maxWidth: 1400,
              mx: "auto",
              width: "100%",
              px: { xs: 2, md: 4 },
            }}
          >
            {/* Logo with image and text - Header */}
            <Box
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mr: 6,
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={synlogo}
                alt="Synthium Logo"
                sx={{
                  width: 40,
                  height: 40,
                  objectFit: "contain",
                }}
              />
              <Box>
                <Typography sx={styles.logoTitle}>SYNTHIUM</Typography>
                <Typography sx={styles.logoSubtitle}>Creative Suite</Typography>
              </Box>
            </Box>

            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 4, flex: 1 }}>
              <Typography
                onClick={() => scrollToSection(toolsRef)}
                sx={styles.navText} // Use black text style
              >
                Features
              </Typography>
              <Typography
                onClick={() => scrollToSection(pricingRef)}
                sx={styles.navText} // Use black text style
              >
                Pricing
              </Typography>
              <Typography
                onClick={() => scrollToSection(teamsRef)}
                sx={styles.navText} // Use black text style
              >
                Teams
              </Typography>
            </Box>

            <Box sx={{ display: "flex", gap: 2, ml: "auto" }}>
              <Button
                variant="text"
                onClick={handleLoginClick} // Add click handler
                sx={{
                  color: "#000000",
                  display: { xs: "none", md: "flex" },
                  fontWeight: 600,
                  "&:hover": { color: G.gold1 },
                }} // Black text
              >
                Log In
              </Button>
              <Button
                variant="contained"
                onClick={handleSignUpClick} // Add click handler
                sx={{
                  background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                  color: "white",
                  borderRadius: "10px",
                  px: 3,
                  fontWeight: 700,
                  fontSize: 14,
                  display: { xs: "none", md: "flex" },
                  boxShadow: `0 4px 20px ${G.gold2}50`,
                  "&:hover": {
                    boxShadow: `0 8px 32px ${G.gold2}70`,
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.2s",
                }}
              >
                Sign Up
              </Button>
              <IconButton
                onClick={() => setDrawer(true)}
                sx={{ display: { md: "none" }, color: "#000000" }}
              >
                <MenuIcon />
              </IconButton>{" "}
              {/* Black icon */}
            </Box>
          </Toolbar>
        </AppBar>

        {/* Mobile Drawer */}
        <Drawer
          anchor="right"
          open={drawer}
          onClose={() => setDrawer(false)}
          PaperProps={{
            sx: {
              background: G.cardBg,
              borderLeft: `1px solid ${G.borderGold}`,
              width: 280,
            },
          }}
        >
          <Box sx={{ p: 3 }}>
            <IconButton
              onClick={() => setDrawer(false)}
              sx={{ color: G.textLight, mb: 2 }}
            >
              <CloseIcon />
            </IconButton>
            <List>
              <ListItem
                onClick={() => scrollToSection(featuresRef)}
                sx={{
                  py: 1.5,
                  color: "#000000",
                  cursor: "pointer",
                  borderRadius: "10px", // Black text
                  "&:hover": { background: `${G.gold2}15`, color: G.gold1 },
                }}
              >
                Features
              </ListItem>
              <ListItem
                onClick={() => scrollToSection(toolsRef)}
                sx={{
                  py: 1.5,
                  color: "#000000",
                  cursor: "pointer",
                  borderRadius: "10px", // Black text
                  "&:hover": { background: `${G.gold2}15`, color: G.gold1 },
                }}
              >
                Tools
              </ListItem>
              <ListItem
                onClick={() => scrollToSection(pricingRef)}
                sx={{
                  py: 1.5,
                  color: "#000000",
                  cursor: "pointer",
                  borderRadius: "10px", // Black text
                  "&:hover": { background: `${G.gold2}15`, color: G.gold1 },
                }}
              >
                Pricing
              </ListItem>
              <ListItem
                onClick={() => scrollToSection(teamsRef)}
                sx={{
                  py: 1.5,
                  color: "#000000",
                  cursor: "pointer",
                  borderRadius: "10px", // Black text
                  "&:hover": { background: `${G.gold2}15`, color: G.gold1 },
                }}
              >
                Teams
              </ListItem>
              <ListItem
                onClick={handleLoginClick} // Add click handler
                sx={{
                  py: 1.5,
                  color: "#000000",
                  cursor: "pointer",
                  borderRadius: "10px", // Black text
                  "&:hover": { background: `${G.gold2}15`, color: G.gold1 },
                }}
              >
                Log In
              </ListItem>
            </List>
            <Button
              fullWidth
              variant="contained"
              onClick={handleSignUpClick} // Add click handler
              sx={{
                mt: 2,
                background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                color: "white",
                borderRadius: "10px",
                fontWeight: 700,
              }}
            >
              Sign Up Free
            </Button>
          </Box>
        </Drawer>

        {/* ── HERO ────────────────────────────────────────────────────────────── */}
        <Box
          ref={featuresRef}
          sx={{
            minHeight: "100vh",
            position: "relative",
            display: "flex",
            alignItems: "center",
            pt: 14,
            pb: 12,
            zIndex: 1,
            // Warm golden gradient background
            background: `
            radial-gradient(ellipse 80% 70% at 50% -10%, ${G.gold4}90 0%, ${G.gold5}60 35%, transparent 65%),
            linear-gradient(180deg, ${G.gold5} 0%, ${G.pageBg} 60%)
          `,
            overflow: "hidden",
          }}
        >
          {/* Floating tool pills scattered in background */}
          <FloatingToolPills />

          {/* Central glowing orb (like the purple sphere in reference) */}
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%,-50%)",
              width: { xs: 180, md: 280 },
              height: { xs: 180, md: 280 },
              borderRadius: "50%",
              background: `radial-gradient(circle at 35% 35%, ${G.gold3}80, ${G.gold1}40, ${G.gold2}20)`,
              boxShadow: `
              0 0 80px ${G.gold3}50,
              0 0 160px ${G.gold2}30,
              inset 0 0 60px ${G.gold4}40
            `,
              opacity: 0.35,
              animation: "orbPulse 5s ease-in-out infinite",
              "@keyframes orbPulse": {
                "0%,100%": {
                  transform: "translate(-50%,-50%) scale(1)",
                  opacity: 0.35,
                },
                "50%": {
                  transform: "translate(-50%,-50%) scale(1.08)",
                  opacity: 0.45,
                },
              },
              zIndex: 2,
              // Orbit rings
              "&::before": {
                content: '""',
                position: "absolute",
                inset: "-20%",
                borderRadius: "50%",
                border: `1.5px solid ${G.gold2}35`,
                animation: "orbitRing1 8s linear infinite",
                "@keyframes orbitRing1": {
                  "0%": { transform: "rotateX(70deg) rotateZ(0deg)" },
                  "100%": { transform: "rotateX(70deg) rotateZ(360deg)" },
                },
              },
              "&::after": {
                content: '""',
                position: "absolute",
                inset: "-50%",
                borderRadius: "50%",
                border: `1px solid ${G.gold3}25`,
                animation: "orbitRing2 12s linear infinite reverse",
                "@keyframes orbitRing2": {
                  "0%": { transform: "rotateX(55deg) rotateZ(0deg)" },
                  "100%": { transform: "rotateX(55deg) rotateZ(360deg)" },
                },
              },
            }}
          />

          {/* Hero content */}
          <Container
            maxWidth="md"
            sx={{ position: "relative", zIndex: 12, textAlign: "center" }}
          >
            {/* Badge */}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1.2,
                px: 3,
                py: 1.2,
                mb: 5,
                borderRadius: 20,
                background: "rgba(255,255,255,0.85)",
                border: `1.5px solid ${G.gold3}70`,
                backdropFilter: "blur(16px)",
                boxShadow: `0 4px 24px ${G.gold2}30`,
                animation: "hBadge 0.9s ease both",
                "@keyframes hBadge": {
                  from: { opacity: 0, transform: "translateY(-20px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <AutoAwesomeIcon sx={{ color: G.gold1, fontSize: 16 }} />
              <Typography
                sx={{ color: G.gold1, fontWeight: 700, fontSize: 13 }}
              >
                27+ AI-Powered Tools · One Creative Suite
              </Typography>
            </Box>

            {/* Headline */}
            <Box
              sx={{
                animation: "hRise 1s ease both",
                "@keyframes hRise": {
                  from: { opacity: 0, transform: "translateY(30px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "3rem",
                    sm: "4rem",
                    md: "5.5rem",
                    lg: "6.5rem",
                  },
                  fontWeight: 900,
                  lineHeight: 1.05,
                  fontFamily: "Sora",
                  display: "block",
                  color: G.textDark,
                }}
              >
                {" "}
                Creative Suite
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "3rem",
                    sm: "4rem",
                    md: "5.5rem",
                    lg: "6.5rem",
                  },
                  fontWeight: 900,
                  lineHeight: 1.05,
                  fontFamily: "Sora",
                  display: "block",
                  mb: 1,
                  background: `linear-gradient(135deg, ${G.gold1} 0%, ${G.gold2} 40%, ${G.gold3} 70%, ${G.gold2} 100%)`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundSize: "200% auto",
                  animation: "shimmer 3s linear infinite",
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "0% center" },
                    "100%": { backgroundPosition: "200% center" },
                  },
                }}
              >
                Built For Makers.
              </Typography>
            </Box>

            <Typography
              sx={{
                color: G.textMid,
                maxWidth: 620,
                mx: "auto",
                mb: 7,
                fontWeight: 400,
                lineHeight: 1.8,
                fontSize: { xs: "1rem", md: "1.15rem" },
                animation: "hRise 1s 0.2s ease both",
              }}
            >
              Write books, generate blogs, check grammar, build brands, create
              ads, translate, humanize AI text, and collaborate on documents —
              all in one unified golden workspace.
            </Typography>

            {/* CTAs */}
            <Box
              sx={{
                display: "flex",
                gap: 3,
                justifyContent: "center",
                flexWrap: "wrap",
                mb: 9,
                animation: "hRise 1s 0.35s ease both",
              }}
            >
              <Button
                size="large"
                variant="contained"
                onClick={handleTryFreeClick} // Add click handler for Try For Free
                sx={{
                  background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                  color: "white",
                  borderRadius: "14px",
                  px: 5,
                  py: 2,
                  fontSize: 16.5,
                  fontWeight: 800,
                  boxShadow: `0 8px 40px ${G.gold2}60`,
                  "&:hover": {
                    boxShadow: `0 16px 64px ${G.gold2}80`,
                    transform:
                      "perspective(400px) rotateX(-5deg) translateY(-3px)",
                  },
                  transition: "all 0.35s cubic-bezier(0.23,1,0.32,1)",
                }}
              >
                Try For Free →
              </Button>
              <Button
                size="large"
                startIcon={<PlayArrowIcon />}
                onClick={() => setDemoOpen(true)}
                sx={{
                  color: G.gold1,
                  borderRadius: "14px",
                  px: 4,
                  py: 2,
                  fontSize: 15.5,
                  fontWeight: 700,
                  border: `2px solid ${G.gold2}60`,
                  background: "rgba(255,255,255,0.8)",
                  backdropFilter: "blur(12px)",
                  "&:hover": {
                    background: `${G.gold4}90`,
                    borderColor: G.gold1,
                  },
                }}
              >
                Watch Demo
              </Button>
            </Box>
          </Container>
        </Box>

        {/* ── TOOLS SECTION ──────────────────────────────────────────────────── */}
        <Box
          ref={toolsRef}
          sx={{ py: 14, position: "relative", zIndex: 1, background: G.pageBg }}
          id="tools"
        >
          <Container maxWidth="lg">
            <SectionHeading
              chip="ALL TOOLS"
              chipColor={G.gold1}
              title="Every Tool. Unique Experience."
              sub="27+ AI tools across 5 categories — each category animates differently so every tool feels alive and intentional."
            />

            {/* Category buttons */}
            <Box sx={{ mb: 7, display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 1.5,
                  flexWrap: "wrap",
                  justifyContent: "center",
                  background: "rgba(255,255,255,0.9)",
                  border: `1.5px solid ${G.borderGold}`,
                  borderRadius: "16px",
                  p: 1.2,
                  boxShadow: `0 4px 24px ${G.gold2}20`,
                }}
              >
                {CATEGORIES.map((cat, i) => (
                  <Button
                    key={cat.label}
                    onClick={() => switchTab(i)}
                    sx={{
                      px: 3,
                      py: 1.2,
                      borderRadius: "10px",
                      fontSize: 13,
                      fontWeight: 700,
                      background:
                        activeTab === i
                          ? `linear-gradient(135deg, ${cat.color}20, ${cat.color}08)`
                          : "transparent",
                      color: activeTab === i ? cat.color : "#000000", // Black text for inactive
                      border:
                        activeTab === i
                          ? `1.5px solid ${cat.color}55`
                          : "1.5px solid transparent",
                      boxShadow:
                        activeTab === i ? `0 4px 16px ${cat.color}25` : "none",
                      "&:hover": {
                        color: cat.color,
                        background: `${cat.color}12`,
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    {cat.label}
                  </Button>
                ))}
              </Box>
            </Box>

            {/* Cards */}
            <Box key={tabKey}>
              <Grid2 container spacing={3}>
                {catTools(CATEGORIES[activeTab].label).map((tool, i) => (
                  <Grid2
                    key={`${tabKey}-${tool.name}`}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                  >
                    <ToolCard
                      tool={tool}
                      anim={CATEGORIES[activeTab].anim}
                      idx={i}
                    />
                  </Grid2>
                ))}
              </Grid2>
            </Box>
          </Container>
        </Box>

        {/* ── ALL TOOLS QUICK-VIEW GRID ─────────────────────────────────────── */}
        <Box
          sx={{
            py: 10,
            background: `linear-gradient(180deg, ${G.pageBg}, ${G.gold5}80, ${G.pageBg})`,
            position: "relative",
            zIndex: 1,
          }}
        >
          <Container maxWidth="lg">
            <Typography
              variant="h5"
              fontWeight={800}
              sx={{
                textAlign: "center",
                mb: 6,
                letterSpacing: -0.5,
                color: "#000000", // Black text
                "& span": {
                  background: `linear-gradient(90deg, ${G.gold1}, ${G.gold2})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                },
              }}
            >
              All <span>27 Tools</span> at a Glance
            </Typography>
            <Grid2 container spacing={1.8}>
              {ALL_TOOLS.map((tool, i) => (
                <Grid2 key={tool.name} xs={6} sm={4} md={3} lg={2}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      gap: 1,
                      px: 1.5,
                      py: 2.5,
                      background: "rgba(255,255,255,0.8)",
                      border: `2px solid ${tool.color}28`,
                      borderRadius: "14px",
                      cursor: "pointer",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                      animation: `qIn 0.5s ${i * 0.025}s ease both`,
                      "@keyframes qIn": {
                        from: {
                          opacity: 0,
                          transform: "scale(0.8) translateY(10px)",
                        },
                        to: { opacity: 1, transform: "scale(1) translateY(0)" },
                      },
                      "&:hover": {
                        border: `1.5px solid ${tool.color}65`,
                        background: `linear-gradient(145deg, ${tool.color}12, rgba(255,255,255,0.95))`,
                        transform: "translateY(-4px) scale(1.04)",
                        boxShadow: `0 12px 30px ${tool.color}25`,
                      },
                      transition: "all 0.28s ease",
                    }}
                  >
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "12px",
                        background: `linear-gradient(135deg, ${tool.color}22, ${tool.color}0A)`,
                        border: `1.5px solid ${tool.color}40`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: tool.color,
                        fontSize: 22,
                      }}
                    >
                      {tool.icon}
                    </Box>
                    <Typography
                      sx={{
                        color: "#000000",
                        fontSize: 11,
                        fontWeight: 700,
                        lineHeight: 1.3,
                      }}
                    >
                      {" "}
                      {/* Black text */}
                      {tool.name}
                    </Typography>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: tool.dot,
                        }}
                      />
                      <Typography sx={{ color: G.textLight, fontSize: 10 }}>
                        {tool.cat}
                      </Typography>
                    </Box>
                  </Box>
                </Grid2>
              ))}
            </Grid2>
          </Container>
        </Box>

        {/* ── SMARTDESK FEATURE ─────────────────────────────────────────────── */}
        <Box
          sx={{ py: 14, position: "relative", zIndex: 1, background: G.pageBg }}
        >
          <Container maxWidth="lg">
            <Grid2 container spacing={8} alignItems="center">
              <Grid2 xs={12} md={6}>
                <Chip
                  label="AI SMARTDESK"
                  sx={{
                    mb: 2,
                    background: `${G.gold2}20`,
                    color: G.gold1,
                    fontWeight: 700,
                    border: `1px solid ${G.gold2}40`,
                  }}
                />
                <Typography
                  variant="h3"
                  fontWeight={900}
                  sx={{
                    fontSize: { xs: "2rem", md: "2.8rem" },
                    mb: 3,
                    lineHeight: 1.2,
                    color: "#000000", // Black text
                  }}
                >
                  Your Command Center for Every AI Tool
                </Typography>
                <Typography
                  sx={{
                    color: G.textLight,
                    mb: 4,
                    lineHeight: 1.8,
                    fontSize: "1.05rem",
                  }}
                >
                  SmartDesk is the unified hub where all 27 tools live side by
                  side. Switch contexts in one click, track every AI session,
                  and build end-to-end creative workflows without losing your
                  place.
                </Typography>
                {[
                  "Unified dashboard across all tools",
                  "AI session history & auto-save",
                  "Cross-tool smart workflows",
                  "Real-time team collaboration",
                ].map((f) => (
                  <Box
                    key={f}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: G.gold1, fontSize: 20 }} />
                    <Typography sx={{ color: "#000000", fontWeight: 500 }}>
                      {f}
                    </Typography>{" "}
                    {/* Black text */}
                  </Box>
                ))}
                <Button
                  variant="contained"
                  sx={{
                    mt: 3,
                    background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                    color: "white",
                    borderRadius: "12px",
                    px: 4,
                    py: 1.5,
                    fontWeight: 700,
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: `0 12px 40px ${G.gold2}60`,
                    },
                    transition: "all 0.2s",
                  }}
                >
                  Explore SmartDesk
                </Button>
              </Grid2>
              <Grid2 xs={12} md={6}>
                {/* 3D mockup */}
                <Box
                  sx={{
                    background: `linear-gradient(145deg, #FFFDF5, #FFF8E0)`,
                    border: `1.5px solid ${G.borderGold}`,
                    borderRadius: "22px",
                    p: 4,
                    transform:
                      "perspective(1200px) rotateY(-12deg) rotateX(5deg)",
                    boxShadow: `40px 40px 100px rgba(180,140,20,0.12), 0 0 0 1px ${G.borderGold}`,
                  }}
                >
                  <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                    {["#E74C3C", "#F1C40F", "#2ECC71"].map((c) => (
                      <Box
                        key={c}
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          background: c,
                        }}
                      />
                    ))}
                    <Typography
                      variant="caption"
                      sx={{ ml: 2, color: G.textLight, fontSize: 11 }}
                    >
                      SmartDesk — Active
                    </Typography>
                  </Box>
                  <Grid2 container spacing={1.5}>
                    {ALL_TOOLS.slice(0, 8).map((tool, i) => (
                      <Grid2 key={i} xs={6}>
                        <Box
                          sx={{
                            p: 1.5,
                            borderRadius: "10px",
                            background: `linear-gradient(135deg, ${tool.color}12, rgba(255,255,255,0.6))`,
                            border: `1px solid ${tool.color}30`,
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                            "&:hover": {
                              border: `1px solid ${tool.color}60`,
                              background: `${tool.color}18`,
                            },
                            transition: "all 0.2s",
                            cursor: "pointer",
                          }}
                        >
                          <Box
                            sx={{
                              color: tool.color,
                              display: "flex",
                              fontSize: 18,
                            }}
                          >
                            {tool.icon}
                          </Box>
                          <Typography
                            sx={{
                              color: "#000000",
                              fontSize: 10.5,
                              fontWeight: 700,
                              lineHeight: 1.2,
                            }}
                          >
                            {" "}
                            {/* Black text */}
                            {tool.name.replace("AI ", "")}
                          </Typography>
                        </Box>
                      </Grid2>
                    ))}
                  </Grid2>
                  <Box
                    sx={{
                      mt: 3,
                      p: 2,
                      borderRadius: "12px",
                      background: `linear-gradient(135deg, ${G.gold4}80, ${G.gold5})`,
                      border: `1px solid ${G.borderGold}`,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ color: G.gold1, fontWeight: 800 }}
                    >
                      ✦ AI SUGGESTION
                    </Typography>
                    <Typography
                      sx={{
                        color: G.textMid,
                        mt: 0.5,
                        fontSize: 12,
                        lineHeight: 1.6,
                      }}
                    >
                      Continue your Brand Strategy doc — 73% complete. Est. 8
                      min to finish.
                    </Typography>
                  </Box>
                </Box>
              </Grid2>
            </Grid2>
          </Container>
        </Box>

        {/* ── SMART TEAMS ───────────────────────────────────────────────────── */}
        <Box
          ref={teamsRef}
          sx={{
            py: 14,
            background: `linear-gradient(180deg, ${G.pageBg}, ${G.gold5}70, ${G.pageBg})`,
            position: "relative",
            zIndex: 1,
          }}
        >
          <Container maxWidth="lg">
            <Grid2 container spacing={8} alignItems="center">
              <Grid2 xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
                <Box
                  sx={{
                    background: `linear-gradient(145deg, #FFFDF5, #FFF8E0)`,
                    border: `1.5px solid ${G.sage}35`,
                    borderRadius: "22px",
                    p: 4,
                    transform:
                      "perspective(1200px) rotateY(12deg) rotateX(5deg)",
                    boxShadow: `-40px 40px 100px rgba(46,125,82,0.08), 0 0 0 1px ${G.borderSoft}`,
                  }}
                >
                  <Typography
                    sx={{
                      color: G.sage,
                      fontWeight: 700,
                      display: "block",
                      mb: 3,
                      fontSize: 12,
                      letterSpacing: 1,
                    }}
                  >
                    ▶ SMART TEAMS · 7 ONLINE
                  </Typography>
                  <Box sx={{ display: "flex", gap: 0.5, mb: 3 }}>
                    {["A", "L", "M", "J", "+3"].map((n, i) => (
                      <Avatar
                        key={i}
                        sx={{
                          width: 34,
                          height: 34,
                          fontSize: 13,
                          fontWeight: 700,
                          background: [
                            G.gold4,
                            `${G.sage}35`,
                            `${G.sky}35`,
                            `${G.coral}35`,
                            "#F0E8D0",
                          ][i],
                          color: [G.gold1, G.sage, G.sky, G.coral, G.textLight][
                            i
                          ],
                          border: `2px solid white`,
                          ml: i > 0 ? -0.5 : 0,
                        }}
                      >
                        {n}
                      </Avatar>
                    ))}
                  </Box>
                  {[
                    "Amara editing Brand Strategy doc",
                    "AI suggested 4 improvements",
                    "Marcus approved Section 3",
                    "Document auto-saved · v14",
                  ].map((msg, i) => (
                    <Box
                      key={i}
                      sx={{
                        display: "flex",
                        gap: 2,
                        mb: 1.8,
                        alignItems: "flex-start",
                      }}
                    >
                      <Box
                        sx={{
                          width: 7,
                          height: 7,
                          borderRadius: "50%",
                          mt: 0.7,
                          flexShrink: 0,
                          background: [G.gold2, G.sage, G.sky, G.teal][i],
                        }}
                      />
                      <Typography
                        sx={{ color: "#000000", fontSize: 13, lineHeight: 1.4 }}
                      >
                        {msg}
                      </Typography>{" "}
                      {/* Black text */}
                    </Box>
                  ))}
                  <Box
                    sx={{
                      mt: 3,
                      height: 5,
                      borderRadius: 3,
                      background: G.borderSoft,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        height: "100%",
                        width: "68%",
                        background: `linear-gradient(90deg, ${G.gold1}, ${G.gold3})`,
                        borderRadius: 3,
                      }}
                    />
                  </Box>
                  <Typography
                    sx={{ color: G.textLight, fontSize: 11, mt: 0.8 }}
                  >
                    Document 68% complete
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
                <Chip
                  label="SMART TEAMS"
                  sx={{
                    mb: 2,
                    background: `${G.sage}18`,
                    color: G.sage,
                    fontWeight: 700,
                    border: `1px solid ${G.sage}35`,
                  }}
                />
                <Typography
                  variant="h3"
                  fontWeight={900}
                  sx={{
                    fontSize: { xs: "2rem", md: "2.8rem" },
                    mb: 3,
                    lineHeight: 1.2,
                    color: "#000000", // Black text
                  }}
                >
                  Collaborate With AI-Augmented Teams
                </Typography>
                <Typography sx={{ color: G.textLight, mb: 4, lineHeight: 1.8 }}>
                  Smart Teams connects everyone with shared AI tools, real-time
                  document collaboration, version history, and intelligent
                  suggestions — all powered by Synthium's AI layer.
                </Typography>
                {[
                  "Real-time multi-user document editing",
                  "AI inline suggestions & auto-rewrites",
                  "Shared prompt & template libraries",
                  "Full version history & one-click rollback",
                ].map((f) => (
                  <Box
                    key={f}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: G.sage, fontSize: 20 }} />
                    <Typography sx={{ color: "#000000", fontWeight: 500 }}>
                      {f}
                    </Typography>{" "}
                    {/* Black text */}
                  </Box>
                ))}
              </Grid2>
            </Grid2>
          </Container>
        </Box>

        {/* ── PRICING ───────────────────────────────────────────────────────── */}
        <Box
          ref={pricingRef}
          sx={{ py: 14, position: "relative", zIndex: 1, background: G.pageBg }}
          id="pricing"
        >
          <Container maxWidth="lg">
            <SectionHeading
              chip="PRICING"
              chipColor={G.teal}
              title="Simple, Transparent Pricing"
              sub="Start free. Scale as you grow. Cancel anytime — no tricks."
            />
            <Grid2 container spacing={3} justifyContent="center">
              {PRICING.map((plan) => (
                <Grid2 key={plan.name} xs={12} sm={6} md={4}>
                  <Card
                    sx={{
                      height: "100%",
                      background: plan.hi
                        ? `linear-gradient(145deg, #FFF9E8, #FFFDF5)`
                        : "#FFFEF9",
                      border: plan.hi
                        ? `2px solid ${G.gold2}`
                        : `1.5px solid ${G.borderSoft}`,
                      borderRadius: "20px",
                      p: 1,
                      position: "relative",
                      overflow: "visible",
                      transform: plan.hi ? "scale(1.05)" : "scale(1)",
                      boxShadow: plan.hi
                        ? `0 24px 80px ${G.gold2}35`
                        : "0 4px 20px rgba(0,0,0,0.05)",
                      "&:hover": {
                        transform: plan.hi
                          ? "scale(1.07) translateY(-4px)"
                          : "translateY(-4px)",
                        boxShadow: `0 20px 60px ${G.gold2}30`,
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    {plan.hi && (
                      <Chip
                        label="Most Popular"
                        sx={{
                          position: "absolute",
                          top: -16,
                          left: "50%",
                          transform: "translateX(-50%)",
                          background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                          color: "white",
                          fontWeight: 700,
                          fontSize: 12,
                        }}
                      />
                    )}
                    <CardContent sx={{ p: 4 }}>
                      <Typography
                        variant="overline"
                        sx={{
                          color: plan.hi ? G.gold1 : "#000000",
                          fontWeight: 700,
                          letterSpacing: 2,
                        }}
                      >
                        {plan.name}
                      </Typography>{" "}
                      {/* Black text */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: 1,
                          my: 2,
                        }}
                      >
                        <Typography
                          variant="h3"
                          fontWeight={900}
                          sx={{ color: "#000000" }}
                        >
                          ${plan.price}
                        </Typography>{" "}
                        {/* Black text */}
                        <Typography sx={{ color: G.textLight, mb: 0.5 }}>
                          /mo
                        </Typography>
                      </Box>
                      <Divider sx={{ borderColor: G.borderSoft, mb: 3 }} />
                      <Stack spacing={1.5} mb={4}>
                        {plan.features.map((f) => (
                          <Box
                            key={f}
                            sx={{
                              display: "flex",
                              gap: 1.5,
                              alignItems: "center",
                            }}
                          >
                            <CheckCircleIcon
                              sx={{
                                fontSize: 16,
                                color: plan.hi ? G.gold1 : G.sage,
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ color: "#000000" }}
                            >
                              {f}
                            </Typography>{" "}
                            {/* Black text */}
                          </Box>
                        ))}
                      </Stack>
                      <Button
                        onClick={() => history.push("/login")}
                        fullWidth
                        sx={
                          plan.hi
                            ? {
                                background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                                color: "white",
                                borderRadius: "12px",
                                py: 1.5,
                                fontWeight: 700,
                                fontSize: 15,
                                "&:hover": {
                                  boxShadow: `0 8px 30px ${G.gold2}60`,
                                },
                              }
                            : {
                                border: `1.5px solid ${G.borderGold}`,
                                color: G.gold1,
                                borderRadius: "12px",
                                py: 1.5,
                                fontWeight: 600,
                                "&:hover": {
                                  background: `${G.gold4}60`,
                                  borderColor: G.gold1,
                                },
                              }
                        }
                      >
                        {plan.cta}
                      </Button>
                    </CardContent>
                  </Card>
                </Grid2>
              ))}
            </Grid2>
          </Container>
        </Box>

        {/* ── TESTIMONIALS ─────────────────────────────────────────────────── */}
        <Box
          sx={{
            py: 12,
            position: "relative",
            zIndex: 1,
            background: `linear-gradient(180deg,${G.pageBg},${G.gold5}60,${G.pageBg})`,
          }}
        >
          <Container maxWidth="lg">
            <SectionHeading
              chip="REVIEWS"
              chipColor={G.rose}
              title="Loved by Makers Worldwide"
            />
            <Grid2 container spacing={3}>
              {TESTIMONIALS.map((t) => (
                <Grid2 key={t.name} xs={12} md={4}>
                  <Card
                    sx={{
                      background: "#FFFEF9",
                      border: `1.5px solid ${G.borderSoft}`,
                      borderRadius: "20px",
                      p: 1,
                      height: "100%",
                      "&:hover": {
                        border: `1.5px solid ${G.borderGold}`,
                        transform: "translateY(-5px)",
                        boxShadow: `0 20px 56px ${G.gold2}22`,
                      },
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                    }}
                  >
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ display: "flex", mb: 2.5 }}>
                        {Array(t.stars)
                          .fill(0)
                          .map((_, j) => (
                            <StarIcon
                              key={j}
                              sx={{ color: G.gold2, fontSize: 18 }}
                            />
                          ))}
                      </Box>
                      <Typography
                        sx={{
                          color: G.textMid,
                          mb: 3,
                          lineHeight: 1.8,
                          fontStyle: "italic",
                          fontSize: "0.93rem",
                        }}
                      >
                        "{t.text}"
                      </Typography>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Avatar
                          sx={{
                            background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                            fontWeight: 700,
                            color: "white",
                          }}
                        >
                          {t.av}
                        </Avatar>
                        <Box>
                          <Typography
                            sx={{ color: "#000000", fontWeight: 700 }}
                            variant="body2"
                          >
                            {t.name}
                          </Typography>{" "}
                          {/* Black text */}
                          <Typography
                            sx={{ color: G.textLight }}
                            variant="caption"
                          >
                            {t.role}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid2>
              ))}
            </Grid2>
          </Container>
        </Box>

        {/* ── FINAL CTA ─────────────────────────────────────────────────────── */}
        <Box
          sx={{
            py: 18,
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            background: `linear-gradient(180deg, ${G.pageBg}, ${G.gold5}90)`,
            overflow: "hidden",
          }}
        >
          {/* big golden glow */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: `radial-gradient(ellipse 70% 60% at 50% 100%, ${G.gold3}35 0%, transparent 65%)`,
            }}
          />
          <Container maxWidth="md" sx={{ position: "relative" }}>
            <Typography
              variant="h2"
              fontWeight={900}
              sx={{
                fontSize: { xs: "2.2rem", md: "4.2rem" },
                mb: 3,
                lineHeight: 1.08,
                background: `linear-gradient(135deg, ${G.textDark} 0%, ${G.gold1} 50%, ${G.gold3} 100%)`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Ready to Create Without Limits?
            </Typography>
            <Typography
              sx={{
                color: G.textMid,
                mb: 7,
                fontSize: "1.2rem",
                maxWidth: 520,
                mx: "auto",
                lineHeight: 1.7,
              }}
            >
              Join 50,000+ creators, writers, and teams already building with
              Synthium.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 3,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Button
                size="large"
                variant="contained"
                onClick={() => history.push("/signup")} // Add click handler for final CTA
                sx={{
                  background: `linear-gradient(135deg, ${G.gold1}, ${G.gold3})`,
                  color: "white",
                  borderRadius: "14px",
                  px: 6,
                  py: 2,
                  fontSize: 18,
                  fontWeight: 800,
                  animation: "ctaGlow 2.5s ease-in-out infinite",
                  "@keyframes ctaGlow": {
                    "0%,100%": { boxShadow: `0 10px 60px ${G.gold2}60` },
                    "50%": { boxShadow: `0 14px 80px ${G.gold3}80` },
                  },
                  "&:hover": { transform: "translateY(-3px) scale(1.03)" },
                  transition: "transform 0.2s",
                }}
              >
                Start Free — No Card Needed
              </Button>
              <Button
                size="large"
                startIcon={<PlayArrowIcon />}
                onClick={() => setDemoOpen(true)}
                sx={{
                  color: G.gold1,
                  borderRadius: "14px",
                  px: 4,
                  py: 2,
                  fontSize: 16,
                  fontWeight: 700,
                  border: `2px solid ${G.gold2}60`,
                  background: "rgba(255,255,255,0.8)",
                  "&:hover": { background: G.gold5, borderColor: G.gold1 },
                }}
              >
                Watch Demo
              </Button>
            </Box>
          </Container>
        </Box>

        {/* ── UPDATED FOOTER ────────────────────────────────────────────────────────── */}
        <Box
          sx={{
            borderTop: `1.5px solid ${G.borderGold}`,
            py: 7,
            position: "relative",
            zIndex: 1,
            background: G.cardBg,
          }}
        >
          <Container maxWidth="lg">
            <Grid2 container spacing={4}>
              <Grid2 xs={12} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={synlogo}
                    alt="Synthium Logo"
                    sx={{
                      width: 36,
                      height: 36,
                      objectFit: "contain",
                    }}
                  />
                  <Box>
                    <Typography sx={styles.footerLogoTitle}>
                      SYNTHIUM
                    </Typography>
                    <Typography sx={styles.footerLogoSubtitle}>
                      Creative Suite
                    </Typography>
                  </Box>
                </Box>

                {/* Address */}
                <Typography sx={styles.footerContactText}>
                  22738, Maple Road Suite 120, Lexington Park, Maryland, 20634
                </Typography>

                {/* Phone */}
                <Typography
                  component="a"
                  href="tel:301-997-5695"
                  sx={styles.footerContactLink}
                >
                  301-997-5695
                </Typography>

                {/* Email */}
                <Typography
                  component="a"
                  href="mailto:admin@synthiumcreative.com"
                  sx={styles.footerContactLink}
                >
                  admin@synthiumcreative.com
                </Typography>

                {/* Social Media Icons */}
                <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                  <IconButton
                    component="a"
                    href="https://www.facebook.com/profile.php?id=61587469183598"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={styles.socialIcon}
                  >
                    <FacebookIcon />
                  </IconButton>
                  <IconButton
                    component="a"
                    href="https://www.linkedin.com/company/synthium-creative"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={styles.socialIcon}
                  >
                    <LinkedInIcon />
                  </IconButton>
                  <IconButton
                    component="a"
                    href="https://twitter.com/synthium_ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={styles.socialIcon}
                  >
                    <TwitterIcon />
                  </IconButton>
                </Box>
              </Grid2>

              <Grid2 xs={12} md={8}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 6,
                    flexWrap: "wrap",
                    justifyContent: { md: "flex-end" },
                  }}
                >
                  {["Product", "Company", "Legal", "Support"].map((s) => (
                    <Box key={s}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: G.textLight,
                          fontWeight: 700,
                          letterSpacing: 1.5,
                          display: "block",
                          mb: 2,
                        }}
                      >
                        {s.toUpperCase()}
                      </Typography>
                      {["Overview", "Docs", "Contact"].map((l) => (
                        <Typography
                          key={l}
                          variant="caption"
                          sx={{
                            display: "block",
                            mb: 1.2,
                            cursor: "pointer",
                            color: "#000000", // Black text
                            "&:hover": { color: G.gold1 },
                            transition: "color 0.2s",
                          }}
                        >
                          {l}
                        </Typography>
                      ))}
                    </Box>
                  ))}
                </Box>
              </Grid2>
            </Grid2>

            <Divider sx={{ my: 5, borderColor: G.borderSoft }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Typography variant="caption" sx={{ color: G.textLight }}>
                © 2026 Synthium Creative Suite. All rights reserved.
              </Typography>
              <Typography variant="caption" sx={{ color: G.textLight }}>
                Built with ✦ for creators everywhere
              </Typography>
            </Box>
          </Container>
        </Box>

        <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
      </Box>
    </ThemeProvider>
  );
}
